webpackJsonp([3],{

/***/ "+KpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compat_compat_component__ = __webpack_require__("l99c");
/* unused harmony export RenderType_CompatComponent */
/* unused harmony export View_CompatComponent_0 */
/* unused harmony export View_CompatComponent_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatComponentNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_CompatComponent = [];
var RenderType_CompatComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_22" /* ɵcrt */]({ encapsulation: 2,
    styles: styles_CompatComponent, data: {} });
function View_CompatComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_23" /* ɵvid */](0, [__WEBPACK_IMPORTED_MODULE_0__angular_core__["_34" /* ɵqud */](402653184, 1, { entryPoint: 0 }), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_24" /* ɵted */](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](16777216, [[1, 3], ['entryPoint', 1]], null, 0, null, null, null, null, null, null, null)), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_24" /* ɵted */](null, ['\n  ']))], null, null);
}
function View_CompatComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_23" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 1, 'webapp-compat', [], null, null, null, View_CompatComponent_0, RenderType_CompatComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_26" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__compat_compat_component__["a" /* CompatComponent */], [[1, __WEBPACK_IMPORTED_MODULE_0__angular_core__["u" /* Injector */]], __WEBPACK_IMPORTED_MODULE_0__angular_core__["v" /* NgModuleFactoryLoader */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CompatComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_27" /* ɵccf */]('webapp-compat', __WEBPACK_IMPORTED_MODULE_1__compat_compat_component__["a" /* CompatComponent */], View_CompatComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0LmNvbXBvbmVudC50cyIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5jb21wb25lbnQudHMuQ29tcGF0Q29tcG9uZW50Lmh0bWwiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2NvbXBhdC9jb21wYXQuY29tcG9uZW50LnRzLkNvbXBhdENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxuZy1jb250YWluZXIgI2VudHJ5UG9pbnQ+PC9uZy1jb250YWluZXI+XG4gICIsIjx3ZWJhcHAtY29tcGF0Pjwvd2ViYXBwLWNvbXBhdD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozt3RENBQTtNQUFBLGFBQ0k7TUFBQTtNQUFBLGdCQUF5Qzs7O29CQ0Q3QztNQUFBO2dDQUFBLFVBQUE7TUFBQTs7SUFBQTs7OzsifQ==
//# sourceMappingURL=compat.component.ngfactory.js.map

/***/ }),

/***/ "+Tzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("Vf+6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__project_feed_transformers__ = __webpack_require__("zHYc");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return navigationProjectFeedReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navigationProjectFeedFailingProjectsReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return navigationProjectFeedFailingContestsReducer; });


var navigationProjectFeedReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationProjectFeed') {
                var ref = action.payload.ref;
                var data = action.payload.data;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__project_feed_transformers__["a" /* transformNavigationProjectFeedItems */])(data), ref);
            }
            return state;
        case 'WS_MESSAGE':
            if (action.payload.type === 'project') {
                var _a = action.payload, data = _a.data, userId = _a.userId;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__project_feed_transformers__["b" /* transformNavigationProjectFeedWS */])(data), { path: ['navigationProjectFeed', userId] }, 'time');
            }
            return state;
        default:
            return state;
    }
};
var navigationProjectFeedFailingProjectsReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationProjectFeedFailingProjects') {
                var ref = action.payload.ref;
                var data = action.payload.data;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__project_feed_transformers__["a" /* transformNavigationProjectFeedItems */])(data), ref);
            }
            return state;
        default:
            return state;
    }
};
var navigationProjectFeedFailingContestsReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationProjectFeedFailingContests') {
                var ref = action.payload.ref;
                var data = action.payload.data;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__project_feed_transformers__["a" /* transformNavigationProjectFeedItems */])(data), ref);
            }
            return state;
        default:
            return state;
    }
};
//# sourceMappingURL=project-feed.reducer.js.map

/***/ }),

/***/ "0A7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ngx_cookie__ = __webpack_require__("Adlr");
/* unused harmony reexport CookieModule */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_ngx_cookie__["b"]; });
// We use https://github.com/salemdar/ngx-cookie, refer to the API docs there.

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "0NQD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformUserRecentProjectsAndContests;
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function transformUserRecentProjectsAndContests(item) {
    return item.list.map(function (listItem) { return (__assign({}, listItem, { urlPart: listItem.type === 'project'
            ? "/projects/" + listItem.urlPart
            : listItem.urlPart })); });
}
//# sourceMappingURL=recent-project-and-contests.transformers.js.map

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("fM0k");


/***/ }),

/***/ "11eB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_memory_leak_tracking_component__ = __webpack_require__("WuZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_error_tracking_service__ = __webpack_require__("KAnv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_config__ = __webpack_require__("YgsG");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_MemoryLeakTrackingComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_MemoryLeakTrackingComponent_0;
/* unused harmony export View_MemoryLeakTrackingComponent_Host_0 */
/* unused harmony export MemoryLeakTrackingComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_MemoryLeakTrackingComponent = [];
var RenderType_MemoryLeakTrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_22" /* ɵcrt */]({ encapsulation: 2,
    styles: styles_MemoryLeakTrackingComponent, data: {} });
function View_MemoryLeakTrackingComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_23" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 0, null, null, null, null, null, null, null))], null, null);
}
function View_MemoryLeakTrackingComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_23" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 1, 'fl-memory-leak-tracking', [], null, null, null, View_MemoryLeakTrackingComponent_0, RenderType_MemoryLeakTrackingComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_26" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_memory_leak_tracking_component__["a" /* MemoryLeakTrackingComponent */], [__WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */], __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var MemoryLeakTrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_27" /* ɵccf */]('fl-memory-leak-tracking', __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_memory_leak_tracking_component__["a" /* MemoryLeakTrackingComponent */], View_MemoryLeakTrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbWVtb3J5LWxlYWstdHJhY2tpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbWVtb3J5LWxlYWstdHJhY2tpbmcuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy9tZW1vcnktbGVhay10cmFja2luZy5jb21wb25lbnQudHMuTWVtb3J5TGVha1RyYWNraW5nQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL21lbW9yeS1sZWFrLXRyYWNraW5nLmNvbXBvbmVudC50cy5NZW1vcnlMZWFrVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC1tZW1vcnktbGVhay10cmFja2luZz48L2ZsLW1lbW9yeS1sZWFrLXRyYWNraW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTs7OztvQkNBQTtNQUFBOzRDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9
//# sourceMappingURL=memory-leak-tracking.component.ngfactory.js.map

/***/ }),

/***/ "2qMh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__websocket__ = __webpack_require__("6Jvl");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__websocket__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__server_message_event_model__ = __webpack_require__("Lz+3");
/* unused harmony reexport WebsocketBaseEvent */
/* unused harmony reexport WebsocketAwardEvent */
/* unused harmony reexport WebsocketAwardBadgeEvent */
/* unused harmony reexport WebsocketAwardCreditEvent */
/* unused harmony reexport WebsocketAwardMilestoneReminderEvent */
/* unused harmony reexport WebsocketAwardReminderEvent */
/* unused harmony reexport WebsocketAwardXpEvent */
/* unused harmony reexport WebsocketBidEvent */
/* unused harmony reexport WebsocketCompletedEvent */
/* unused harmony reexport WebsocketContactRequestReceivedEvent */
/* unused harmony reexport WebsocketContestEvent */
/* unused harmony reexport WebsocketContestAwardedToEmployerEvent */
/* unused harmony reexport WebsocketContestAwardedToFreelancerEvent */
/* unused harmony reexport WebsocketContestEntryEvent */
/* unused harmony reexport WebsocketContestEntryBoughtToEmployerEvent */
/* unused harmony reexport WebsocketContestEntryBoughtToFreelancerEvent */
/* unused harmony reexport WebsocketContestPCBNotificationEvent */
/* unused harmony reexport WebsocketContestPCBNotificationFullViewEvent */
/* unused harmony reexport WebsocketCreateMilestoneEvent */
/* unused harmony reexport WebsocketDenyedEvent */
/* unused harmony reexport WebsocketDraftContestEvent */
/* unused harmony reexport WebsocketFailingProjectEvent */
/* unused harmony reexport WebsocketHighLtvAnnualDiscountEvent */
/* unused harmony reexport WebsocketInviteToContestEvent */
/* unused harmony reexport WebsocketInviteUserBidEvent */
/* unused harmony reexport WebsocketInvoiceRequestedEvent */
/* unused harmony reexport WebsocketLevelupEvent */
/* unused harmony reexport WebsocketNotifyfollowerEvent */
/* unused harmony reexport WebsocketProjectEvent */
/* unused harmony reexport WebsocketProjectRecruiterEvent */
/* unused harmony reexport WebsocketQuickHireProjectEvent */
/* unused harmony reexport WebsocketReleaseMilestoneEvent */
/* unused harmony reexport WebsocketRequestEndProjectEvent */
/* unused harmony reexport WebsocketRequestMilestoneEvent */
/* unused harmony reexport WebsocketRequestToReleaseEvent */
/* unused harmony reexport WebsocketServiceApprovedEvent */
/* unused harmony reexport WebsocketServiceProjectEndingSellerEvent */
/* unused harmony reexport WebsocketServiceProjectPostedSellerEvent */
/* unused harmony reexport WebsocketServiceRejectedEvent */
/* unused harmony reexport WebsocketSignUpFreeTrialUpsellEvent */
/* unused harmony reexport WebsocketSitesBinCreatedEvent */
/* unused harmony reexport WebsocketSitesHandOverMessageSentEvent */
/* unused harmony reexport WebsocketSitesListingStatusChangedEvent */
/* unused harmony reexport WebsocketSitesMessageSentEvent */
/* unused harmony reexport WebsocketSitesOfferCreatedEvent */
/* unused harmony reexport WebsocketUpsellCrowdsourceFindingEvent */
/* unused harmony reexport WebsocketXpContestEvent */


//# sourceMappingURL=index.js.map

/***/ }),

/***/ "3PDT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("Vf+6");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return giveGetEligibilityReducer; });
/* unused harmony export transformGiveGetEligibility */

var giveGetEligibilityReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'giveGetEligibility') {
                var _a = action.payload, data = _a.data, ref = _a.ref;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["d" /* mergeEntity */])(state, transformGiveGetEligibility(data), ref.path);
            }
            return state;
        default:
            return state;
    }
};
function transformGiveGetEligibility(eligible) {
    return eligible;
}
//# sourceMappingURL=give-get.reducer.js.map

/***/ }),

/***/ "5KmC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("Vf+6");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messageReducer; });

var messageReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            {
                if (action.payload && action.payload.ref.path[0] === 'messages') {
                    var _a = action.payload, data = _a.data, ref = _a.ref;
                    var messages = data.messages.reduce(function (acc, message) {
                        acc[message.id] = message;
                        return acc;
                    }, {});
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, messages, ref);
                }
            }
            return state;
        case 'API_POST':
        case 'API_POST_SUCCESS': {
            if (action.payload && action.payload.ref.path[0] === 'messages') {
                var _b = action.payload, message = _b.data, ref = _b.ref;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, (_c = {}, _c[message.id] = message, _c), ref);
            }
            return state;
        }
        /*case 'RECEIVED_MESSAGE_FROM_SOCKET': {
          const oldMessage = state[action.payload.thread_id].filter((
            (message: any) => ((
              message.client_message_id === action.payload.client_message_id
            ))
          ))[0] || {};
          const messageList: Array<any> = (state[action.payload.thread_id] || [])
            .filter((message: any) => (
              message.client_message_id !== action.payload.client_message_id
            ));
          messageList.push(Object.assign({}, oldMessage, action.payload));
    
          const threadId: any = action.payload.thread_id;
          let newThreads: any = {};
          newThreads[threadId] = messageList;
          return Object.assign({}, state, newThreads);
        }*/
        default:
            return state;
    }
    var _c;
};
//# sourceMappingURL=message.reducer.js.map

/***/ }),

/***/ "6Jvl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_auth__ = __webpack_require__("W4ip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__("rlar");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__ = __webpack_require__("bKpL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject__ = __webpack_require__("gvep");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("Vf+6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datastore_config__ = __webpack_require__("b0JN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__datastore_interface__ = __webpack_require__("t1Sn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__datastore_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__datastore_interface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__multiset__ = __webpack_require__("BcKS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sock_js__ = __webpack_require__("BaqR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__server_message_event_model__ = __webpack_require__("Lz+3");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WebSocketService; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/* A library for working with SockJS websockets.
 * This is somewhat based on rxjs-websockets but with a lot of customisations
 * for freelancer.
 */











var WebSocketService = (function () {
    function WebSocketService(datastoreConfig, auth, store) {
        this.datastoreConfig = datastoreConfig;
        this.auth = auth;
        this.store = store;
        this.connectionStatus = new __WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject__["BehaviorSubject"](0);
        this.fromServerStream = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.onlineOfflineSubs = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.open = false;
        this.channels = new Set();
        this.userSubscriptions = new __WEBPACK_IMPORTED_MODULE_8__multiset__["a" /* MultiSet */]();
        this.create();
        this.subscribeChannels([3]); // FIXME: Call this properly.
    }
    WebSocketService.prototype.create = function () {
        var _this = this;
        this.open = false;
        this.sock = new __WEBPACK_IMPORTED_MODULE_9__sock_js__["a" /* Socket */](this.datastoreConfig.webSocketUrl);
        this.auth.distinctUntilChanged().subscribe(function (auth) {
            _this.open = false;
            var closed = function () {
                if (!_this.open) {
                    return;
                }
                _this.connectionStatus.next(_this.connectionStatus.getValue() - 1);
                _this.onlineOfflineSubscription.unsubscribe();
                _this.open = false;
            };
            _this.sock.onopen = function () {
                _this.open = true;
                _this.connectionStatus.next(_this.connectionStatus.getValue() + 1);
                _this.sendEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__sock_js__["b" /* generateHeader */])(auth));
                _this.subscribeToUserEvents();
            };
            // Only send events with actual messages, not handshaking messages.
            _this.sock.onmessage = function (event) {
                var decodedEvent = JSON.parse(event.data);
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__server_message_event_model__["a" /* isSockMessageServerEvent */])(decodedEvent)) {
                    _this.processEvent(decodedEvent, auth.uid);
                }
            };
            _this.sock.onclose = function (event) {
                closed();
                if (event.wasClean) {
                    _this.fromServerStream.complete();
                }
                else {
                    _this.fromServerStream.error(new Error(event.reason));
                }
            };
            return function () {
                if (_this.sock) {
                    closed();
                    _this.sock.close();
                }
            };
        });
    };
    WebSocketService.prototype.sendEvent = function (message) {
        if (this.open) {
            this.sock.send(message);
        }
        else {
            console.error('Tried sending a message to a closed websocket.');
        }
    };
    WebSocketService.prototype.processEvent = function (event, userId) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__server_message_event_model__["b" /* isOnlineOfflineEvent */])(event)) {
            // The type of online/offline websockets is "statusget" :(
            this.store.dispatch({
                type: 'WS_MESSAGE',
                payload: {
                    data: event.body.data,
                    type: 'onlineOffline',
                    userId: String(userId),
                },
            });
        }
        else {
            this.store.dispatch({
                type: 'WS_MESSAGE',
                payload: __assign({}, event.body, { userId: String(userId) }),
            });
        }
        // Once the store is updated then we can let everyone know.
        this.fromServerStream.next(event);
    };
    /* We buffer the user subscriptions and unsubscriptions by 1 second
      * to reduce backend load.
      * It's possible to have subscribed and unsubscriped within that buffer
      * so we remove such sub/unsub (and reverse) manually.
    */
    WebSocketService.prototype.subscribeToUserEvents = function () {
        var _this = this;
        // Subscribe to existing subscriptions
        var existingSubscriptions = this.userSubscriptions.values();
        if (existingSubscriptions.length) {
            this.sendEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__sock_js__["c" /* generateUserSub */])(existingSubscriptions));
        }
        if (this.channels.size) {
            this.sendEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__sock_js__["d" /* generateChannelSubMessage */])(Array.from(this.channels)));
        }
        // Subscribe to any new ones that come in
        this.onlineOfflineSubscription = this.onlineOfflineSubs
            .bufferTime(1000)
            .subscribe(function (userIds) {
            var reducedSubscriptions = userIds.reduce(function (acc, current) {
                var subs = acc.subs;
                var unsubs = acc.unsubs;
                if (current.type === 'sub') {
                    if (acc.unsubs.includes(current.id)) {
                        unsubs = acc.unsubs.filter(function (id) { return id !== current.id; });
                    }
                    else {
                        subs = acc.subs.concat([current.id]);
                    }
                }
                if (current.type === 'unsub') {
                    if (acc.subs.includes(current.id)) {
                        subs = acc.subs.filter(function (id) { return id !== current.id; });
                    }
                    else {
                        unsubs = acc.unsubs.concat([current.id]);
                    }
                }
                return { subs: subs, unsubs: unsubs };
            }, { subs: [], unsubs: [] });
            if (reducedSubscriptions.subs.length) {
                _this.sendEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__sock_js__["c" /* generateUserSub */])(reducedSubscriptions.subs));
            }
            if (reducedSubscriptions.unsubs.length) {
                _this.sendEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__sock_js__["e" /* generateUserUnsub */])(reducedSubscriptions.unsubs));
            }
            return;
        });
    };
    WebSocketService.prototype.subscribeOnlineOffline = function (userId) {
        var _this = this;
        // Watch the user id stream, calculate watch for changes,
        // subscribe/unsubscribe to any additions/removals respectively
        // and return the user status for the user who is subscribed to.
        // We add `undefined` to the end so we can get the last unsub.
        return userId
            .distinctUntilChanged()
            .concat(__WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__["Observable"].of(undefined))
            .scan(function (acc, next) { return ({
            current: next,
            previous: acc.current,
        }); }, {
            current: undefined,
            previous: undefined,
        })
            .map(function (_a) {
            var previous = _a.previous, current = _a.current;
            if (previous) {
                _this.unsubscribeUserOnlineOffline(previous);
            }
            if (current) {
                _this.subscribeUserOnlineOffline(current);
            }
            return current;
        });
    };
    WebSocketService.prototype.subscribeUserOnlineOffline = function (userId) {
        // If this user id is new, subscribe.
        if (this.userSubscriptions.multiplicity(userId) === 0) {
            this.onlineOfflineSubs.next({ type: 'sub', id: userId });
        }
        this.userSubscriptions.add(userId);
    };
    WebSocketService.prototype.unsubscribeUserOnlineOffline = function (userId) {
        // If this user id is the last one, unsubscribe.
        if (this.userSubscriptions.multiplicity(userId) === 1) {
            this.onlineOfflineSubs.next({ type: 'unsub', id: userId });
        }
        this.userSubscriptions.remove(userId);
    };
    WebSocketService.prototype.subscribeChannels = function (channels) {
        var _this = this;
        this.sendEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__sock_js__["d" /* generateChannelSubMessage */])(channels));
        channels.forEach(function (channel) { return _this.channels.add(channel); });
    };
    WebSocketService.prototype.unsubscribeChannels = function (channels) {
        console.log('Not implemented');
    };
    WebSocketService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_7__datastore_interface__["DatastoreConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_6__datastore_config__["a" /* DATASTORE_CONFIG */]] }] }, { type: __WEBPACK_IMPORTED_MODULE_1__shared_auth__["a" /* Auth */] }, { type: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* Store */] }]; };
    return WebSocketService;
}());

//# sourceMappingURL=websocket.js.map

/***/ }),

/***/ "7x6H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_auth__ = __webpack_require__("W4ip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_cookie__ = __webpack_require__("0A7D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__ = __webpack_require__("bKpL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracking_config__ = __webpack_require__("YgsG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tracking_interface__ = __webpack_require__("Ebf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tracking_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tracking_interface__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tracking; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var Tracking = (function () {
    function Tracking(http, auth, cookies, config) {
        var _this = this;
        this.http = http;
        this.auth = auth;
        this.cookies = cookies;
        this.config = config;
        this.MAX_GET_LENGTH = 2000;
        this.sequenceNum = 0;
        var sessionId = this.cookies.get(this.config.sessionCookie);
        if (!sessionId) {
            // Generate a new one if not.
            sessionId = this.generateSessionId();
            this.cookies.put('_tracking_session', sessionId, {
                expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
            });
        }
        this.sessionId = sessionId;
        // send the event backlog if any
        try {
            var backlog = localStorage.getItem('trackingBacklog');
            if (backlog) {
                var itemsMap = JSON.parse(backlog);
                Object.values(itemsMap).forEach(function (item) {
                    _this.sendBeacon(item);
                });
            }
            localStorage.setItem('trackingBacklog', JSON.stringify({}));
        }
        catch (e) {
            // ignore the errors, e.g. quota is full or security error
            console.error(e);
        }
    }
    Tracking.prototype.track = function (eventName, eventData) {
        var _this = this;
        return this.auth
            .switchMap(function (_a) {
            var uid = _a.uid;
            var e = __assign({
                acct: window.location.hostname.replace(/^www/, ''),
                t: Date.now().toString(),
                en: eventName,
                location: window.location.href,
                user_id: uid ? uid : undefined,
                session_id: _this.sessionId,
            }, eventData);
            return _this.sendBeacon(e);
        })
            .toPromise();
    };
    Tracking.prototype.generateSessionId = function () {
        var s4 = function () {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        };
        return "" + s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
    };
    Tracking.prototype.sendBeacon = function (payload) {
        var _this = this;
        var beaconId = this.sequenceNum++;
        // save the event for later in case of a hard navigation
        try {
            var backlog = JSON.parse(localStorage.getItem('trackingBacklog') || '{}');
            backlog[beaconId] = payload;
            localStorage.setItem('trackingBacklog', JSON.stringify(backlog));
        }
        catch (e) {
            // ignore the errors, e.g. quota is full or security error
            console.error(e);
        }
        return (__WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(payload)
            .delay(100)
            .switchMap(function (e) { return _this.http.post(_this.config.trackingEndpoint, e); })
            .do(function () {
            // Remove the event from the backlog once it has been sent
            try {
                var backlog2 = JSON.parse(localStorage.getItem('trackingBacklog') || '{}');
                delete backlog2[beaconId];
                localStorage.setItem('trackingBacklog', JSON.stringify(backlog2));
            }
            catch (e) {
                // ignore the errors, e.g. quota is full or security error
                console.error(e);
            }
        })
            .mapTo(undefined)
            .toPromise());
    };
    Tracking.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_http__["h" /* Http */] }, { type: __WEBPACK_IMPORTED_MODULE_2__shared_auth__["a" /* Auth */] }, { type: __WEBPACK_IMPORTED_MODULE_3__shared_cookie__["a" /* CookieService */] }, { type: __WEBPACK_IMPORTED_MODULE_6__tracking_interface__["TrackingConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_5__tracking_config__["a" /* TRACKING_CONFIG */]] }] }]; };
    return Tracking;
}());

//# sourceMappingURL=tracking.service.js.map

/***/ }),

/***/ "81Ll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackingComponent; });
var TrackingComponent = (function () {
    function TrackingComponent() {
    }
    return TrackingComponent;
}());

//# sourceMappingURL=tracking.component.js.map

/***/ }),

/***/ "AiWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracking_service__ = __webpack_require__("7x6H");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserTimingTrackingComponent; });

var UserTimingTrackingComponent = (function () {
    function UserTimingTrackingComponent(t) {
        this.t = t;
        this.timingMarkOffset = 0; // keep track of the timing marks already reported
    }
    UserTimingTrackingComponent.prototype.ngOnInit = function () {
        // Only enable if the browser supports the User Timing API
        // (http://caniuse.com/#feat=user-timing)
        if (!(window.performance && window.performance.getEntriesByType)) {
            return;
        }
        this.reportTimingMarks();
    };
    UserTimingTrackingComponent.prototype.reportTimingMarks = function () {
        var _this = this;
        window.requestIdleCallback(function () {
            var marks = window.performance.getEntriesByType('mark');
            if (marks.length > _this.timingMarkOffset) {
                for (var i = _this.timingMarkOffset; i < marks.length; i++) {
                    var mark = marks[i];
                    var t = Math.round(mark.startTime);
                    if (t >= 0 && t < 3600000) {
                        var p = {
                            mark_name: mark.name,
                            mark_time: t,
                        };
                        if (!mark.name.startsWith('Zone')) {
                            _this.t.track('user_timing', p);
                        }
                    }
                    _this.timingMarkOffset += marks.length;
                }
            }
            // Use the Page Visibility API to stop the collection if available
            if (document.hidden) {
                var onVisible_1 = function () {
                    document.removeEventListener('visibilitychange', onVisible_1);
                    setTimeout(function () { return _this.reportTimingMarks(); }, 1000);
                };
                document.addEventListener('visibilitychange', onVisible_1);
            }
            else {
                // TODO: User PerformanceObserver when it's more widely supported
                setTimeout(function () { return _this.reportTimingMarks(); }, 1000);
            }
        });
    };
    UserTimingTrackingComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__tracking_service__["a" /* Tracking */] }]; };
    return UserTimingTrackingComponent;
}());

//# sourceMappingURL=user-timing-tracking.component.js.map

/***/ }),

/***/ "AmkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_service__ = __webpack_require__("gsd3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_config__ = __webpack_require__("EURK");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthModule; });


var AuthModule = (function () {
    function AuthModule() {
    }
    AuthModule.initialize = function (config) {
        return {
            ngModule: AuthModule,
            providers: [__WEBPACK_IMPORTED_MODULE_0__auth_service__["a" /* Auth */], { provide: __WEBPACK_IMPORTED_MODULE_1__auth_config__["a" /* AUTH_CONFIG */], useValue: config }],
        };
    };
    return AuthModule;
}());

//# sourceMappingURL=auth.module.js.map

/***/ }),

/***/ "BaqR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sockjs_client__ = __webpack_require__("bzuB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sockjs_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sockjs_client__);
/* harmony export (immutable) */ __webpack_exports__["c"] = generateUserSub;
/* harmony export (immutable) */ __webpack_exports__["e"] = generateUserUnsub;
/* harmony export (immutable) */ __webpack_exports__["d"] = generateChannelSubMessage;
/* harmony export (immutable) */ __webpack_exports__["b"] = generateHeader;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Socket; });
/* A wrapper around SockJS so that we make sure that we only
 * send messages of types that our backend supports.
 *
 * Contains both the types of messages sent and received as well as
 * helper functions to construct these.
 */

var State;
(function (State) {
    State[State["CONNECTING"] = 0] = "CONNECTING";
    State[State["OPEN"] = 1] = "OPEN";
    State[State["CLOSING"] = 2] = "CLOSING";
    State[State["CLOSED"] = 3] = "CLOSED";
})(State || (State = {}));
function generateUserSub(userIds) {
    return {
        channel: 'onlineoffline',
        body: {
            route: 'getsub',
            users: userIds,
        },
    };
}
function generateUserUnsub(userIds) {
    return {
        channel: 'onlineoffline',
        body: {
            route: 'unsub',
            users: userIds,
        },
    };
}
function generateChannelSubMessage(channels) {
    return {
        channel: 'channels',
        body: { channels: channels },
    };
}
function generateHeader(auth) {
    return {
        channel: 'auth',
        body: {
            hash2: auth.token,
            user_id: auth.uid,
        },
    };
}
var Socket = (function () {
    function Socket(url) {
        var _this = this;
        this.sock = new __WEBPACK_IMPORTED_MODULE_0_sockjs_client__(url);
        this.sock.onopen = function (e) { return _this.onopen(e); };
        this.sock.onclose = function (e) { return _this.onclose(e); };
        this.sock.onmessage = function (e) { return _this.onmessage(e); };
    }
    Socket.prototype.readyState = function () {
        return this.sock.readyState;
    };
    Socket.prototype.send = function (message) {
        this.sock.send(JSON.stringify(message));
    };
    Socket.prototype.close = function (code, reason) {
        this.sock.close(code, reason);
    };
    return Socket;
}());

//# sourceMappingURL=sock-js.js.map

/***/ }),

/***/ "BcKS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultiSet; });
/* An implementation of a multiset.
 * Heavily modified from the npm package cell-multiset.
*/
var MultiSet = (function () {
    function MultiSet(elms) {
        var _this = this;
        this.elements = new Map();
        if (elms) {
            elms.forEach(function (elm) { return _this.add(elm); });
        }
        return this;
    }
    MultiSet.prototype.add = function () {
        var elms = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elms[_i] = arguments[_i];
        }
        return this.addCollection(elms);
    };
    MultiSet.prototype.addCollection = function (elms) {
        var _this = this;
        elms.forEach(function (elm) {
            _this.elements.set(elm, (_this.elements.get(elm) || 0) + 1);
        });
        return this;
    };
    Object.defineProperty(MultiSet.prototype, "cardinality", {
        get: function () {
            var len = 0;
            this.elements.forEach(function (multiplicity) { return (len += multiplicity); });
            return len;
        },
        enumerable: true,
        configurable: true
    });
    MultiSet.prototype.clear = function () {
        this.elements.clear();
        return this;
    };
    MultiSet.prototype.contains = function (multiset) {
        var _this = this;
        var found = true;
        multiset.elements.forEach(function (multiplicity, elm) {
            if (multiplicity > _this.multiplicity(elm)) {
                found = false;
                return;
            }
        });
        return found;
    };
    MultiSet.prototype.difference = function (multiset) {
        var _this = this;
        this.elements.forEach(function (multiplicity, elm) {
            var nmul = multiplicity - multiset.multiplicity(elm);
            if (nmul <= 0) {
                _this.elements.delete(elm);
            }
            else {
                _this.elements.set(elm, nmul);
            }
        });
        return this;
    };
    MultiSet.prototype.Difference = function (multiset) {
        var output = new MultiSet();
        this.elements.forEach(function (multiplicity, elm) {
            var nmul = multiplicity - multiset.multiplicity(elm);
            if (nmul > 0) {
                output.elements.set(elm, nmul);
            }
        });
        return output;
    };
    MultiSet.prototype.each = function (callback, ctx) {
        var _this = this;
        var all = true;
        this.elements.forEach(function (mul, elm) {
            if (callback.call(ctx, elm, mul, _this) === false) {
                all = false;
                return;
            }
        });
        return all;
    };
    MultiSet.prototype.entries = function () {
        return this.elements.entries();
    };
    MultiSet.prototype.equals = function (multiset) {
        var _this = this;
        return multiset.each(function (mul, elm) {
            return mul !== _this.multiplicity(elm);
        });
    };
    MultiSet.prototype.has = function (elm) {
        return !!this.elements.get(elm);
    };
    MultiSet.prototype.isEmpty = function () {
        return !!this.elements.size;
    };
    MultiSet.prototype.intersection = function (multiset) {
        var _this = this;
        var nmul;
        this.elements.forEach(function (multiplicity, elm) {
            nmul = Math.min(multiplicity, multiset.multiplicity(elm));
            if (!nmul) {
                _this.elements.delete(elm);
            }
            else {
                _this.elements.set(elm, nmul);
            }
        });
        return this;
    };
    MultiSet.prototype.Intersection = function (multiset) {
        var output = new MultiSet();
        var nmul;
        this.elements.forEach(function (multiplicity, elm) {
            nmul = Math.min(multiplicity, multiset.multiplicity(elm));
            if (nmul) {
                output.elements.set(elm, nmul);
            }
        });
        return output;
    };
    MultiSet.prototype.isSubsetOf = function (multiset) {
        return multiset.contains(this);
    };
    MultiSet.prototype.keys = function () {
        return this.elements.keys();
    };
    MultiSet.prototype.multiplicity = function (elm) {
        return this.elements.get(elm) || 0;
    };
    MultiSet.prototype.remove = function () {
        var elms = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elms[_i] = arguments[_i];
        }
        return this.removeCollection(elms);
    };
    MultiSet.prototype.removeCollection = function (elms) {
        var _this = this;
        elms.forEach(function (elm) {
            var multiplicity = _this.elements.get(elm) || 0;
            if (multiplicity === 1) {
                _this.elements.delete(elm);
            }
            else {
                _this.elements.set(elm, Math.max(0, multiplicity - 1));
            }
        });
        return this;
    };
    MultiSet.prototype.symmetricDifference = function (multiset) {
        var _this = this;
        multiset.elements.forEach(function (multiplicity, elm) {
            var diff = _this.multiplicity(elm) - multiplicity;
            if (!diff) {
                _this.elements.delete(elm);
            }
            else {
                _this.elements.set(elm, Math.abs(diff));
            }
        });
        return this;
    };
    MultiSet.prototype.union = function (multiset) {
        var _this = this;
        multiset.elements.forEach(function (multiplicity, elm) {
            return _this.elements.set(elm, Math.max(multiplicity, _this.multiplicity(elm)));
        });
        return this;
    };
    MultiSet.prototype.values = function () {
        return Array.from(this.elements.keys());
    };
    return MultiSet;
}());

//# sourceMappingURL=multiset.js.map

/***/ }),

/***/ "EURK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_CONFIG; });

var AUTH_CONFIG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* OpaqueToken */]('AuthConfig');
//# sourceMappingURL=auth.config.js.map

/***/ }),

/***/ "Ebf1":
/***/ (function(module, exports) {

//# sourceMappingURL=tracking.interface.js.map

/***/ }),

/***/ "FXv2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_tracking_service__ = __webpack_require__("KAnv");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomErrorHandler; });

var CustomErrorHandler = (function () {
    function CustomErrorHandler(errorTracking) {
        this.errorTracking = errorTracking;
    }
    CustomErrorHandler.prototype.handleError = function (error) {
        this.errorTracking.captureException(error);
    };
    CustomErrorHandler.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__error_tracking_service__["a" /* ErrorTracking */] }]; };
    return CustomErrorHandler;
}());

//# sourceMappingURL=custom-error-handler.service.js.map

/***/ }),

/***/ "J7eJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatNavigationComponent; });
var CompatNavigationComponent = (function () {
    function CompatNavigationComponent() {
    }
    return CompatNavigationComponent;
}());

//# sourceMappingURL=compat-navigation.component.js.map

/***/ }),

/***/ "JTSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracking_service__ = __webpack_require__("7x6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracking_config__ = __webpack_require__("YgsG");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoXSRFStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TrackingModule; });


var NoXSRFStrategy = (function () {
    function NoXSRFStrategy() {
    }
    NoXSRFStrategy.prototype.configureRequest = function (req) {
        // Remove `x-xsrf-token` from request headers since the tracking backend
        // doesn't care, and it avoids uneeded CORS preflight requests
    };
    return NoXSRFStrategy;
}());

var TrackingModule = (function () {
    function TrackingModule() {
    }
    TrackingModule.initialize = function (config) {
        return {
            ngModule: TrackingModule,
            providers: [__WEBPACK_IMPORTED_MODULE_0__tracking_service__["a" /* Tracking */], { provide: __WEBPACK_IMPORTED_MODULE_1__tracking_config__["a" /* TRACKING_CONFIG */], useValue: config }],
        };
    };
    return TrackingModule;
}());

//# sourceMappingURL=tracking.module.js.map

/***/ }),

/***/ "KAnv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__("uTHT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_auth__ = __webpack_require__("W4ip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_config__ = __webpack_require__("YgsG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_interface__ = __webpack_require__("Ebf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tracking_interface__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorTracking; });





var ErrorTracking = (function () {
    function ErrorTracking(auth, config) {
        this.auth = auth;
        this.config = config;
        if (this.config.enableErrorTracking) {
            __WEBPACK_IMPORTED_MODULE_0_raven_js__["config"](this.config.sentryDsn, {
                release: this.config.gitRevision,
                tags: {
                    releaseDate: this.config.buildDate,
                },
            });
        }
    }
    ErrorTracking.prototype.captureMessage = function (msg, options) {
        var _this = this;
        if (this.config.enableErrorTracking) {
            this.auth
                .map(function (_a) {
                var uid = _a.uid;
                _this.setUserId(uid);
                __WEBPACK_IMPORTED_MODULE_0_raven_js__["captureMessage"](msg, options);
            })
                .toPromise();
        }
        else {
            console.error(msg, options);
        }
    };
    ErrorTracking.prototype.captureException = function (error) {
        var _this = this;
        if (this.config.enableErrorTracking) {
            this.auth
                .map(function (_a) {
                var uid = _a.uid;
                _this.setUserId(uid);
                __WEBPACK_IMPORTED_MODULE_0_raven_js__["captureException"](error);
            })
                .toPromise();
        }
        else {
            console.error(error);
        }
    };
    ErrorTracking.prototype.setUserId = function (id) {
        if (id) {
            __WEBPACK_IMPORTED_MODULE_0_raven_js__["setUserContext"]({ id: String(id) });
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0_raven_js__["setUserContext"]();
        }
    };
    ErrorTracking.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__shared_auth__["a" /* Auth */] }, { type: __WEBPACK_IMPORTED_MODULE_4__tracking_interface__["TrackingConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_3__tracking_config__["a" /* TRACKING_CONFIG */]] }] }]; };
    return ErrorTracking;
}());

//# sourceMappingURL=error-tracking.service.js.map

/***/ }),

/***/ "LGet":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatModule; });
// /!\ DO ADD ANYTHING IN THERE WITHOUT TALKING TO FRONTEND INFRA FIRST /!\
var CompatModule = (function () {
    function CompatModule() {
    }
    return CompatModule;
}());

//# sourceMappingURL=compat.module.js.map

/***/ }),

/***/ "LHQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return backend; });
var backend = {
    giveGetEligibility: {
        fetch: function () { return ({
            endpoint: "users/0.1/referral_invitations/check",
            params: {
                bonus_id: '16',
            },
        }); },
    },
    messages: {
        fetch: function (key) { return ({
            endpoint: "messages/0.1/messages",
            params: { 'threads[]': key },
        }); },
        post: function (key) { return ({
            endpoint: "messages/0.1/threads/" + key + "/messages/",
            params: {
                thread_id: key,
            },
        }); },
    },
    navigationNotifications: {
        fetch: function () { return ({
            endpoint: "newsfeed/0.1/newsfeed/notifications",
            params: {},
        }); },
    },
    navigationProjectFeed: {
        fetch: function () { return ({
            endpoint: "navigation/project-feed/pre-populated.php",
            isGaf: true,
            params: {},
        }); },
    },
    navigationProjectFeedFailingProjects: {
        fetch: function () { return ({
            endpoint: "navigation/project-feed/pre-populated-xp-projectcontest.php",
            isGaf: true,
            params: { type: 'p' },
        }); },
    },
    navigationProjectFeedFailingContests: {
        fetch: function () { return ({
            endpoint: "navigation/project-feed/pre-populated-xp-projectcontest.php",
            isGaf: true,
            params: { type: 'c' },
        }); },
    },
    navigationUserBalances: {
        fetch: function () { return ({
            endpoint: "users/0.1/self",
            params: { balance_details: 1 },
        }); },
    },
    navigationUserInfo: {
        fetch: function () { return ({
            endpoint: "navigation/user-info.php",
            isGaf: true,
            params: {},
        }); },
    },
    navigationUserRecentProjectsAndContests: {
        fetch: function () { return ({
            endpoint: "navigation/recent-projects-and-contests.php",
            isGaf: true,
            params: {},
        }); },
    },
    notificationsUserPreferences: {
        fetch: function () { return ({
            endpoint: "notifications/preferences.php",
            isGaf: true,
            params: {},
        }); },
        post: function (key) { return ({
            endpoint: "notifications/set-preferences.php",
            isGaf: true,
        }); },
    },
    onlineOffline: {},
    threads: {
        fetch: function (key) { return ({
            endpoint: "messages/0.1/threads",
            params: {
                unread_count: 'true',
                last_message: 'true',
                message_details: 'true',
                context_details: 'true',
                user_details: 'true',
            },
        }); },
    },
    threadUnreadCount: {},
};
//# sourceMappingURL=backend.js.map

/***/ }),

/***/ "Lgsa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_cookie__ = __webpack_require__("0A7D");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyntheticPerformanceTrackingComponent; });


var SyntheticPerformanceTrackingComponent = (function () {
    function SyntheticPerformanceTrackingComponent(cookies, renderer) {
        this.cookies = cookies;
        this.renderer = renderer;
    }
    SyntheticPerformanceTrackingComponent.prototype.ngOnInit = function () {
        /**
         * Adds a 'sc-no-animation' class on the root element ('html') when a
         * 'no_animation' cookie is present. This can then be used to disable CSS
         * animations / transitions as they don't play nice with synthetics monitoring
         * & visual completness score (a.k.a. Speed Index).
         */
        if (this.cookies.get('no_animation')) {
            this.renderer.addClass(document.documentElement, 'sc-no-animation');
        }
    };
    SyntheticPerformanceTrackingComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__shared_cookie__["a" /* CookieService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_15" /* Renderer2 */] }]; };
    return SyntheticPerformanceTrackingComponent;
}());

//# sourceMappingURL=synthetic-performance-tracking.component.js.map

/***/ }),

/***/ "Lz+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isOnlineOfflineEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = isSockMessageServerEvent;
/**
 * This file has the message formats for the different messages that are
 * received by the client from the websocket.
 *
 * Each websocket `message` contains an `event` that has a `type` and `data`.
 * These `events` are then reused by the `store` and `actions`.
 */
function isOnlineOfflineEvent(event) {
    return (event.channel === 'user' &&
        event.body &&
        event.body.parent_type === 'onlineoffline');
}
function isSockMessageServerEvent(event) {
    return event.channel === 'user';
}
//# sourceMappingURL=server-message-event.model.js.map

/***/ }),

/***/ "QnNn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("bKpL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjectObservable; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ObjectObservable = (function (_super) {
    __extends(ObjectObservable, _super);
    function ObjectObservable(ref$, apiHttp, store, source) {
        var _this = _super.call(this) || this;
        _this.ref$ = ref$;
        _this.apiHttp = apiHttp;
        _this.store = store;
        _this.source = source;
        return _this;
    }
    ObjectObservable.prototype.lift = function (operator) {
        var observable = new ObjectObservable(this.ref$, this.apiHttp, this.store, this);
        observable.operator = operator;
        return observable;
    };
    ObjectObservable.prototype.set = function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(undefined);
    };
    ObjectObservable.prototype.update = function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(undefined);
    };
    ObjectObservable.prototype.remove = function () {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(undefined);
    };
    return ObjectObservable;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"]));

//# sourceMappingURL=object-observable.js.map

/***/ }),

/***/ "SD0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compat_compat_module__ = __webpack_require__("LGet");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compat_compat_component__ = __webpack_require__("l99c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_component_ngfactory__ = __webpack_require__("YbRK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compat_component_ngfactory__ = __webpack_require__("+KpY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_common__ = __webpack_require__("qbdv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__ = __webpack_require__("fc+i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_animations_browser__ = __webpack_require__("f9zQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__ = __webpack_require__("fL27");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_animations__ = __webpack_require__("EyWH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_tracking_module__ = __webpack_require__("JTSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ngrx_store_devtools_src_extension__ = __webpack_require__("M/iR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__ = __webpack_require__("PbkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ngrx_store_devtools_src_devtools__ = __webpack_require__("ooAe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ngrx_store_src_dispatcher__ = __webpack_require__("ymMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__ = __webpack_require__("gOQ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ngrx_store_src_reducer__ = __webpack_require__("b2X0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ngrx_store_devtools_src_config__ = __webpack_require__("CcDZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ngrx_store_src_state__ = __webpack_require__("8LMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ngrx_store_src_store__ = __webpack_require__("QI4+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__app_shared_datastore_api_http_service__ = __webpack_require__("z11m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__app_shared_auth_auth_service__ = __webpack_require__("gsd3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__app_shared_datastore_datastore_config__ = __webpack_require__("b0JN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__app_shared_datastore_store__ = __webpack_require__("Vf+6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__app_shared_datastore_websocket_websocket__ = __webpack_require__("6Jvl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__app_shared_datastore_datastore__ = __webpack_require__("oZs6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__app_shared_tracking_tracking_service__ = __webpack_require__("7x6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_ngx_cookie_src_cookie_service__ = __webpack_require__("9wrn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__app_shared_tracking_tracking_config__ = __webpack_require__("YgsG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__app_shared_auth_auth_config__ = __webpack_require__("EURK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_ngx_cookie_src_cookie_options_provider__ = __webpack_require__("0yYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_ngx_cookie_src_cookie_factory__ = __webpack_require__("k47s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__app_shared_tracking_error_tracking_service__ = __webpack_require__("KAnv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__app_shared_tracking_custom_error_handler_service__ = __webpack_require__("FXv2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_ngx_cookie_index__ = __webpack_require__("Adlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__app_shared_auth_auth_module__ = __webpack_require__("AmkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__app_shared_datastore_datastore_module__ = __webpack_require__("mU2B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__angular_router__ = __webpack_require__("BkNc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__app_shared_tracking_tracking_component__ = __webpack_require__("81Ll");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__compat_compat_navigation_component__ = __webpack_require__("J7eJ");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatModuleNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */









































var CompatModuleNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["b" /* ɵcmf */](__WEBPACK_IMPORTED_MODULE_1__compat_compat_module__["a" /* CompatModule */], [__WEBPACK_IMPORTED_MODULE_2__compat_compat_component__["a" /* CompatComponent */]], function (_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["c" /* ɵmod */]([__WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["e" /* ComponentFactoryResolver */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["f" /* ɵCodegenComponentFactoryResolver */], [[8, [__WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_component_ngfactory__["a" /* TrackingComponentNgFactory */], __WEBPACK_IMPORTED_MODULE_4__compat_component_ngfactory__["a" /* CompatComponentNgFactory */]]], [3, __WEBPACK_IMPORTED_MODULE_0__angular_core__["e" /* ComponentFactoryResolver */]],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["g" /* NgModuleRef */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["h" /* LOCALE_ID */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["i" /* ɵm */], [[3, __WEBPACK_IMPORTED_MODULE_0__angular_core__["h" /* LOCALE_ID */]]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_5__angular_common__["a" /* NgLocalization */], __WEBPACK_IMPORTED_MODULE_5__angular_common__["b" /* NgLocaleLocalization */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["h" /* LOCALE_ID */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_0__angular_core__["j" /* Compiler */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["j" /* Compiler */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["k" /* APP_ID */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["l" /* ɵf */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["m" /* IterableDiffers */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["n" /* ɵk */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* KeyValueDiffers */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["p" /* ɵl */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["b" /* DomSanitizer */], __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["c" /* ɵe */], [__WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["d" /* DOCUMENT */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](6144, __WEBPACK_IMPORTED_MODULE_0__angular_core__["q" /* Sanitizer */], null, [__WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["b" /* DomSanitizer */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["e" /* HAMMER_GESTURE_CONFIG */], __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["f" /* HammerGestureConfig */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["g" /* EVENT_MANAGER_PLUGINS */], function (p0_0, p1_0, p2_0, p2_1) {
            return [new __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["h" /* ɵDomEventsPlugin */](p0_0), new __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["i" /* ɵKeyEventsPlugin */](p1_0), new __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["j" /* ɵHammerGesturesPlugin */](p2_0, p2_1)];
        }, [__WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["d" /* DOCUMENT */], __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["d" /* DOCUMENT */], __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["d" /* DOCUMENT */], __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["e" /* HAMMER_GESTURE_CONFIG */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["k" /* EventManager */], __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["k" /* EventManager */], [__WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["g" /* EVENT_MANAGER_PLUGINS */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["r" /* NgZone */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](135680, __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["l" /* ɵDomSharedStylesHost */], __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["l" /* ɵDomSharedStylesHost */], [__WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["d" /* DOCUMENT */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["m" /* ɵDomRendererFactory2 */], __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["m" /* ɵDomRendererFactory2 */], [__WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["k" /* EventManager */],
            __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["l" /* ɵDomSharedStylesHost */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_7__angular_animations_browser__["a" /* AnimationDriver */], __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__["a" /* ɵc */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_7__angular_animations_browser__["b" /* ɵAnimationStyleNormalizer */], __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__["b" /* ɵd */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_7__angular_animations_browser__["c" /* ɵAnimationEngine */], __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__["c" /* ɵb */], [__WEBPACK_IMPORTED_MODULE_7__angular_animations_browser__["a" /* AnimationDriver */], __WEBPACK_IMPORTED_MODULE_7__angular_animations_browser__["b" /* ɵAnimationStyleNormalizer */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_0__angular_core__["s" /* RendererFactory2 */], __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__["d" /* ɵe */], [__WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["m" /* ɵDomRendererFactory2 */], __WEBPACK_IMPORTED_MODULE_7__angular_animations_browser__["c" /* ɵAnimationEngine */],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["r" /* NgZone */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](6144, __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["n" /* ɵSharedStylesHost */], null, [__WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["l" /* ɵDomSharedStylesHost */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_0__angular_core__["t" /* Testability */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["t" /* Testability */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["r" /* NgZone */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["o" /* Meta */], __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["o" /* Meta */], [__WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["d" /* DOCUMENT */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["p" /* Title */], __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["p" /* Title */], [__WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["d" /* DOCUMENT */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_9__angular_animations__["a" /* AnimationBuilder */], __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__["e" /* ɵBrowserAnimationBuilder */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["s" /* RendererFactory2 */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_10__angular_http__["a" /* BrowserXhr */], __WEBPACK_IMPORTED_MODULE_10__angular_http__["a" /* BrowserXhr */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_10__angular_http__["b" /* ResponseOptions */], __WEBPACK_IMPORTED_MODULE_10__angular_http__["c" /* BaseResponseOptions */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_10__angular_http__["d" /* XSRFStrategy */], __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_tracking_module__["a" /* NoXSRFStrategy */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_10__angular_http__["e" /* XHRBackend */], __WEBPACK_IMPORTED_MODULE_10__angular_http__["e" /* XHRBackend */], [__WEBPACK_IMPORTED_MODULE_10__angular_http__["a" /* BrowserXhr */], __WEBPACK_IMPORTED_MODULE_10__angular_http__["b" /* ResponseOptions */], __WEBPACK_IMPORTED_MODULE_10__angular_http__["d" /* XSRFStrategy */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_10__angular_http__["f" /* RequestOptions */], __WEBPACK_IMPORTED_MODULE_10__angular_http__["g" /* BaseRequestOptions */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_10__angular_http__["h" /* Http */], __WEBPACK_IMPORTED_MODULE_10__angular_http__["i" /* ɵc */], [__WEBPACK_IMPORTED_MODULE_10__angular_http__["e" /* XHRBackend */], __WEBPACK_IMPORTED_MODULE_10__angular_http__["f" /* RequestOptions */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_12__ngrx_store_devtools_src_extension__["a" /* REDUX_DEVTOOLS_EXTENSION */], __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__["a" /* _createReduxDevtoolsExtension */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_12__ngrx_store_devtools_src_extension__["b" /* DevtoolsExtension */], __WEBPACK_IMPORTED_MODULE_12__ngrx_store_devtools_src_extension__["b" /* DevtoolsExtension */], [__WEBPACK_IMPORTED_MODULE_12__ngrx_store_devtools_src_extension__["a" /* REDUX_DEVTOOLS_EXTENSION */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_14__ngrx_store_devtools_src_devtools__["a" /* DevtoolsDispatcher */], __WEBPACK_IMPORTED_MODULE_14__ngrx_store_devtools_src_devtools__["a" /* DevtoolsDispatcher */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_15__ngrx_store_src_dispatcher__["a" /* Dispatcher */], __WEBPACK_IMPORTED_MODULE_15__ngrx_store_src_dispatcher__["a" /* Dispatcher */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["a" /* INITIAL_REDUCER */], __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["b" /* _initialReducerFactory */], [__WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["c" /* _INITIAL_REDUCER */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_17__ngrx_store_src_reducer__["a" /* Reducer */], __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__["b" /* _createReducerIfExtension */], [__WEBPACK_IMPORTED_MODULE_12__ngrx_store_devtools_src_extension__["a" /* REDUX_DEVTOOLS_EXTENSION */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["u" /* Injector */], __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["a" /* INITIAL_REDUCER */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["d" /* INITIAL_STATE */], __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["e" /* _initialStateFactory */], [__WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["f" /* _INITIAL_STATE */], __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["a" /* INITIAL_REDUCER */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_18__ngrx_store_devtools_src_config__["a" /* STORE_DEVTOOLS_CONFIG */], __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__["c" /* _createOptions */], [__WEBPACK_IMPORTED_MODULE_18__ngrx_store_devtools_src_config__["b" /* INITIAL_OPTIONS */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_14__ngrx_store_devtools_src_devtools__["b" /* StoreDevtools */], __WEBPACK_IMPORTED_MODULE_14__ngrx_store_devtools_src_devtools__["b" /* StoreDevtools */], [__WEBPACK_IMPORTED_MODULE_14__ngrx_store_devtools_src_devtools__["a" /* DevtoolsDispatcher */],
            __WEBPACK_IMPORTED_MODULE_15__ngrx_store_src_dispatcher__["a" /* Dispatcher */], __WEBPACK_IMPORTED_MODULE_17__ngrx_store_src_reducer__["a" /* Reducer */], __WEBPACK_IMPORTED_MODULE_12__ngrx_store_devtools_src_extension__["b" /* DevtoolsExtension */], __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["d" /* INITIAL_STATE */], __WEBPACK_IMPORTED_MODULE_18__ngrx_store_devtools_src_config__["a" /* STORE_DEVTOOLS_CONFIG */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_19__ngrx_store_src_state__["a" /* State */], __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__["d" /* _createStateIfExtension */], [__WEBPACK_IMPORTED_MODULE_12__ngrx_store_devtools_src_extension__["a" /* REDUX_DEVTOOLS_EXTENSION */],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["u" /* Injector */], __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["d" /* INITIAL_STATE */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_20__ngrx_store_src_store__["a" /* Store */], __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["g" /* _storeFactory */], [__WEBPACK_IMPORTED_MODULE_15__ngrx_store_src_dispatcher__["a" /* Dispatcher */], __WEBPACK_IMPORTED_MODULE_17__ngrx_store_src_reducer__["a" /* Reducer */], __WEBPACK_IMPORTED_MODULE_19__ngrx_store_src_state__["a" /* State */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_21__app_shared_datastore_api_http_service__["a" /* ApiHttp */], __WEBPACK_IMPORTED_MODULE_21__app_shared_datastore_api_http_service__["a" /* ApiHttp */], [__WEBPACK_IMPORTED_MODULE_10__angular_http__["e" /* XHRBackend */], __WEBPACK_IMPORTED_MODULE_10__angular_http__["f" /* RequestOptions */], __WEBPACK_IMPORTED_MODULE_22__app_shared_auth_auth_service__["a" /* Auth */], __WEBPACK_IMPORTED_MODULE_23__app_shared_datastore_datastore_config__["a" /* DATASTORE_CONFIG */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](5120, __WEBPACK_IMPORTED_MODULE_24__app_shared_datastore_store__["a" /* Store */], __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["g" /* _storeFactory */], [__WEBPACK_IMPORTED_MODULE_15__ngrx_store_src_dispatcher__["a" /* Dispatcher */], __WEBPACK_IMPORTED_MODULE_17__ngrx_store_src_reducer__["a" /* Reducer */], __WEBPACK_IMPORTED_MODULE_19__ngrx_store_src_state__["a" /* State */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_25__app_shared_datastore_websocket_websocket__["a" /* WebSocketService */], __WEBPACK_IMPORTED_MODULE_25__app_shared_datastore_websocket_websocket__["a" /* WebSocketService */], [__WEBPACK_IMPORTED_MODULE_23__app_shared_datastore_datastore_config__["a" /* DATASTORE_CONFIG */],
            __WEBPACK_IMPORTED_MODULE_22__app_shared_auth_auth_service__["a" /* Auth */], __WEBPACK_IMPORTED_MODULE_24__app_shared_datastore_store__["a" /* Store */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_26__app_shared_datastore_datastore__["a" /* Datastore */], __WEBPACK_IMPORTED_MODULE_26__app_shared_datastore_datastore__["a" /* Datastore */], [__WEBPACK_IMPORTED_MODULE_24__app_shared_datastore_store__["a" /* Store */],
            __WEBPACK_IMPORTED_MODULE_21__app_shared_datastore_api_http_service__["a" /* ApiHttp */], __WEBPACK_IMPORTED_MODULE_25__app_shared_datastore_websocket_websocket__["a" /* WebSocketService */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_27__app_shared_tracking_tracking_service__["a" /* Tracking */], __WEBPACK_IMPORTED_MODULE_27__app_shared_tracking_tracking_service__["a" /* Tracking */], [__WEBPACK_IMPORTED_MODULE_10__angular_http__["h" /* Http */], __WEBPACK_IMPORTED_MODULE_22__app_shared_auth_auth_service__["a" /* Auth */], __WEBPACK_IMPORTED_MODULE_28_ngx_cookie_src_cookie_service__["a" /* CookieService */], __WEBPACK_IMPORTED_MODULE_29__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](4608, __WEBPACK_IMPORTED_MODULE_0__angular_core__["v" /* NgModuleFactoryLoader */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["w" /* SystemJsNgModuleLoader */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["j" /* Compiler */], [2, __WEBPACK_IMPORTED_MODULE_0__angular_core__["x" /* SystemJsNgModuleLoaderConfig */]]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_5__angular_common__["c" /* CommonModule */], __WEBPACK_IMPORTED_MODULE_5__angular_common__["c" /* CommonModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](256, __WEBPACK_IMPORTED_MODULE_30__app_shared_auth_auth_config__["a" /* AUTH_CONFIG */], { baseUrl: 'https://www.freelancer.com/auth', authHashCookie: 'GETAFREE_AUTH_HASH_V2',
            userIdCookie: 'GETAFREE_USER_ID' }, []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](256, __WEBPACK_IMPORTED_MODULE_31_ngx_cookie_src_cookie_options_provider__["a" /* COOKIE_OPTIONS */], {}, []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_31_ngx_cookie_src_cookie_options_provider__["b" /* CookieOptionsProvider */], __WEBPACK_IMPORTED_MODULE_31_ngx_cookie_src_cookie_options_provider__["b" /* CookieOptionsProvider */], [__WEBPACK_IMPORTED_MODULE_31_ngx_cookie_src_cookie_options_provider__["a" /* COOKIE_OPTIONS */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["u" /* Injector */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](1024, __WEBPACK_IMPORTED_MODULE_28_ngx_cookie_src_cookie_service__["a" /* CookieService */], __WEBPACK_IMPORTED_MODULE_32_ngx_cookie_src_cookie_factory__["a" /* cookieServiceFactory */], [__WEBPACK_IMPORTED_MODULE_31_ngx_cookie_src_cookie_options_provider__["b" /* CookieOptionsProvider */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_22__app_shared_auth_auth_service__["a" /* Auth */], __WEBPACK_IMPORTED_MODULE_22__app_shared_auth_auth_service__["a" /* Auth */], [__WEBPACK_IMPORTED_MODULE_30__app_shared_auth_auth_config__["a" /* AUTH_CONFIG */],
            __WEBPACK_IMPORTED_MODULE_28_ngx_cookie_src_cookie_service__["a" /* CookieService */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](256, __WEBPACK_IMPORTED_MODULE_29__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */], { trackingEndpoint: 'https://t.freelancer.com/0px.gif',
            sessionCookie: '_tracking_session', navigationPerformanceSamplingRate: 1,
            enableErrorTracking: true, sentryDsn: 'https://89961363a0f642558f5fedad5195eb89@sentry.io/85230',
            gitRevision: '99ef035f96d', buildDate: 'Tue Jul 11 2017 08:58:34 GMT-0400 (EDT)' }, []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_33__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */], __WEBPACK_IMPORTED_MODULE_33__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */], [__WEBPACK_IMPORTED_MODULE_22__app_shared_auth_auth_service__["a" /* Auth */],
            __WEBPACK_IMPORTED_MODULE_29__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["y" /* ErrorHandler */], __WEBPACK_IMPORTED_MODULE_34__app_shared_tracking_custom_error_handler_service__["a" /* CustomErrorHandler */], [__WEBPACK_IMPORTED_MODULE_33__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](1024, __WEBPACK_IMPORTED_MODULE_0__angular_core__["z" /* APP_INITIALIZER */], function (p0_0, p0_1) {
            return [__WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["q" /* ɵc */](p0_0, p0_1)];
        }, [[2, __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["r" /* NgProbeToken */]], [2, __WEBPACK_IMPORTED_MODULE_0__angular_core__["A" /* NgProbeToken */]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["B" /* ApplicationInitStatus */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["B" /* ApplicationInitStatus */], [[2, __WEBPACK_IMPORTED_MODULE_0__angular_core__["z" /* APP_INITIALIZER */]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](131584, __WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* ɵe */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* ɵe */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["r" /* NgZone */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["D" /* ɵConsole */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["u" /* Injector */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["y" /* ErrorHandler */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["e" /* ComponentFactoryResolver */],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["B" /* ApplicationInitStatus */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](2048, __WEBPACK_IMPORTED_MODULE_0__angular_core__["E" /* ApplicationRef */], null, [__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* ɵe */]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* ApplicationModule */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* ApplicationModule */], [__WEBPACK_IMPORTED_MODULE_0__angular_core__["E" /* ApplicationRef */]]),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["s" /* BrowserModule */], __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["s" /* BrowserModule */], [[3, __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["s" /* BrowserModule */]]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__["f" /* BrowserAnimationsModule */], __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__["f" /* BrowserAnimationsModule */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_35_ngx_cookie_index__["a" /* CookieModule */], __WEBPACK_IMPORTED_MODULE_35_ngx_cookie_index__["a" /* CookieModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_36__app_shared_auth_auth_module__["a" /* AuthModule */], __WEBPACK_IMPORTED_MODULE_36__app_shared_auth_auth_module__["a" /* AuthModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_10__angular_http__["j" /* HttpModule */], __WEBPACK_IMPORTED_MODULE_10__angular_http__["j" /* HttpModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["h" /* StoreModule */], __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["h" /* StoreModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__["e" /* StoreDevtoolsModule */], __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__["e" /* StoreDevtoolsModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_37__app_shared_datastore_datastore_module__["a" /* DatastoreModule */], __WEBPACK_IMPORTED_MODULE_37__app_shared_datastore_datastore_module__["a" /* DatastoreModule */], []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_tracking_module__["b" /* TrackingModule */], __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_tracking_module__["b" /* TrackingModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](512, __WEBPACK_IMPORTED_MODULE_1__compat_compat_module__["a" /* CompatModule */], __WEBPACK_IMPORTED_MODULE_1__compat_compat_module__["a" /* CompatModule */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](256, __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["c" /* _INITIAL_REDUCER */], __WEBPACK_IMPORTED_MODULE_24__app_shared_datastore_store__["b" /* store */], []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](256, __WEBPACK_IMPORTED_MODULE_16__ngrx_store_src_ng2__["f" /* _INITIAL_STATE */], undefined, []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](256, __WEBPACK_IMPORTED_MODULE_18__ngrx_store_devtools_src_config__["b" /* INITIAL_OPTIONS */], { maxAge: 5 }, []),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](256, __WEBPACK_IMPORTED_MODULE_23__app_shared_datastore_datastore_config__["a" /* DATASTORE_CONFIG */], { apiBaseUrl: 'https://www.freelancer.com/api',
            ajaxBaseUrl: 'https://www.freelancer.com/ajax-api', webSocketUrl: 'https://notifications.freelancer.com' }, []), __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* ɵmpd */](1024, __WEBPACK_IMPORTED_MODULE_38__angular_router__["a" /* ROUTES */], function () {
            return [[{ selector: 'webapp-compat-tracking', loadChildren: 'app/@shared/tracking/tracking.module#TrackingModule',
                        component: __WEBPACK_IMPORTED_MODULE_39__app_shared_tracking_tracking_component__["a" /* TrackingComponent */], path: 'hack_path_not_used' }, { selector: 'webapp-compat-navigation',
                        loadChildren: 'compat/compat-navigation.module#CompatNavigationModule',
                        component: __WEBPACK_IMPORTED_MODULE_40__compat_compat_navigation_component__["a" /* CompatNavigationComponent */], path: 'hack_path_not_used' }]];
        }, [])]);
});
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0Lm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==
//# sourceMappingURL=compat.module.ngfactory.js.map

/***/ }),

/***/ "T09Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformNavigationUserInfo;
// This takes an API response and transforms it into a User object
function transformNavigationUserInfo(navigation) {
    return {
        id: navigation.id,
        username: navigation.username,
        publicName: navigation.publicName,
        isFreeTrialEligible: navigation.isFreeTrialEligible,
        isPlusTrialEligible: navigation.isPlusTrialEligible,
        trialPackageId: navigation.trialPackageId,
        isPremium: navigation.isPremium,
        logo: navigation.logo,
        membership: navigation.membership,
        hideMembershipUpgradeButton: navigation.hideMembershipUpgradeButton,
        trialDuration: navigation.trialDuration,
        trialLandingUrlParams: navigation.trialLandingUrlParams,
        monthlyTrial: navigation.monthlyTrial,
        canSwitchToUsers: navigation.canSwitchToUsers,
        isNoCommissionEligibleReferrer: navigation.isNoCommissionEligibleReferrer,
    };
}
//# sourceMappingURL=user-info.transformers.js.map

/***/ }),

/***/ "Vf+6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngrx_store__ = __webpack_require__("JgC9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngrx_core_compose__ = __webpack_require__("WrqG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngrx_core_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ngrx_core_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngrx_store_freeze__ = __webpack_require__("Tvzk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngrx_store_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ngrx_store_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__message_message_reducer__ = __webpack_require__("5KmC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__ = __webpack_require__("bUqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__give_get_give_get_reducer__ = __webpack_require__("3PDT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__online_offline_online_offline_reducer__ = __webpack_require__("mAhR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__thread_thread_reducer__ = __webpack_require__("ySlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notification_preferences_notification_preferences_reducer__ = __webpack_require__("Xszc");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
/* harmony export (immutable) */ __webpack_exports__["c"] = mergeEntities;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeEntity;
/* harmony export (immutable) */ __webpack_exports__["b"] = store;
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









/* Wrap ngrx's Store as our own Store that only takes our action types. */
var Store = (function (_super) {
    __extends(Store, _super);
    function Store() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Store.prototype.dispatch = function (action) {
        _super.prototype.dispatch.call(this, action);
    };
    Store.prototype.next = function (action) {
        _super.prototype.next.call(this, action);
    };
    return Store;
}(__WEBPACK_IMPORTED_MODULE_0__ngrx_store__["a" /* Store */]));

function compare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function arrayMerge(a, b) {
    var result = [];
    var max = Math.max(a.length, b.length);
    for (var i = 0; i < max; i++) {
        if (a[i] || b[i]) {
            result[i] = a[i] || b[i];
        }
    }
    return result;
}
function arrayShift(a, offset) {
    return new Array(offset).concat(a);
}
/* This merges a number of entities into the state.
 * If an offset it specified then the new entities are placed at that offset.
 * If an offset is not specified then the new entities will be:
 *   - merged if they have the same id as an existing entity OR
 *   - placed at the start of the list (and the offset of existing items moved up)
 *
 * We also allow a custom sorting function to allow resorting the list.
 * If this is used all the offsets will be then be reindexed from 0.
 */
function mergeEntities(state, entities, ref, sortKey) {
    var data = state[ref.path[1]] || { entities: {} };
    var query = 'default'; // FIXME
    var originalList = data.lists ? data.lists[query].slice() || [] : [];
    var updatedEntities = __assign({}, data.entities, entities);
    var newEntityIds = Object.keys(updatedEntities).filter(function (key) { return !Object.keys(data.entities).includes(key); });
    // If the new list doesn't have an offset then the new list is put at the front.
    var originalListOffset = ref.query && ref.query.offset ? 0 : newEntityIds.length;
    var newListOffset = (ref.query && ref.query.offset) || 0;
    var updatedQueryList = arrayMerge(arrayShift(originalList, originalListOffset), arrayShift(newEntityIds, newListOffset));
    if (sortKey) {
        updatedQueryList.sort(function (a, b) {
            return compare(updatedEntities[a][sortKey], updatedEntities[b][sortKey]);
        });
    }
    return Object.assign({}, state, (_a = {},
        _a[ref.path[1]] = {
            entities: updatedEntities,
            lists: __assign({}, data.lists, (_b = {}, _b[query] = updatedQueryList, _b)),
        },
        _a));
    var _a, _b;
}
function mergeEntity(state, entity, path) {
    return Object.assign({}, state, (_a = {}, _a[path[1]] = entity, _a));
    var _a;
}
function store(state, action) {
    var reducers = {
        giveGetEligibility: __WEBPACK_IMPORTED_MODULE_5__give_get_give_get_reducer__["a" /* giveGetEligibilityReducer */],
        messages: __WEBPACK_IMPORTED_MODULE_3__message_message_reducer__["a" /* messageReducer */],
        navigationNotifications: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["a" /* navigationNotificationsReducer */],
        navigationProjectFeed: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["b" /* navigationProjectFeedReducer */],
        navigationProjectFeedFailingContests: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["c" /* navigationProjectFeedFailingContestsReducer */],
        navigationProjectFeedFailingProjects: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["d" /* navigationProjectFeedFailingProjectsReducer */],
        navigationUserBalances: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["e" /* navigationUserBalancesReducer */],
        navigationUserInfo: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["f" /* navigationUserInfoReducer */],
        navigationUserRecentProjectsAndContests: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["g" /* navigationUserRecentProjectsAndContestsReducer */],
        notificationsUserPreferences: __WEBPACK_IMPORTED_MODULE_8__notification_preferences_notification_preferences_reducer__["a" /* notificationsUserPreferencesReducer */],
        onlineOffline: __WEBPACK_IMPORTED_MODULE_6__online_offline_online_offline_reducer__["a" /* onlineOfflineReducer */],
        threads: __WEBPACK_IMPORTED_MODULE_7__thread_thread_reducer__["a" /* threadReducer */],
        threadUnreadCount: __WEBPACK_IMPORTED_MODULE_7__thread_thread_reducer__["b" /* threadUnreadCountReducer */],
    };
    var reducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ngrx_core_compose__["compose"])(__WEBPACK_IMPORTED_MODULE_2_ngrx_store_freeze__["storeFreeze"], __WEBPACK_IMPORTED_MODULE_0__ngrx_store__["b" /* combineReducers */])(reducers);
    return reducer(state, action);
}
//# sourceMappingURL=store.js.map

/***/ }),

/***/ "W4ip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_config__ = __webpack_require__("EURK");
/* unused harmony reexport AUTH_CONFIG */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_interface__ = __webpack_require__("e8+Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__auth_interface__);
/* unused harmony reexport AuthConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_module__ = __webpack_require__("AmkE");
/* unused harmony reexport AuthModule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_service__ = __webpack_require__("gsd3");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__auth_service__["a"]; });
/* unused harmony reexport AuthState */




//# sourceMappingURL=index.js.map

/***/ }),

/***/ "WuZe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_tracking_service__ = __webpack_require__("KAnv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracking_config__ = __webpack_require__("YgsG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_interface__ = __webpack_require__("Ebf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tracking_interface__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MemoryLeakTrackingComponent; });




var MemoryLeakTrackingComponent = (function () {
    function MemoryLeakTrackingComponent(errorTracking, config) {
        this.errorTracking = errorTracking;
        this.config = config;
        this.CHECK_INTERVAL = 10000; // 10 seconds
        this.MAX_MEMORY_LIMIT = 1000 * 1048576; // 1000MB
        this.MAX_PERCENT_THRESHOLD = 90;
        this.hadAlarmed = false;
    }
    MemoryLeakTrackingComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!(window.performance && window.performance.memory)) {
            return;
        }
        setTimeout(function () { return _this.checkMemoryUsage(); }, this.CHECK_INTERVAL);
    };
    MemoryLeakTrackingComponent.prototype.checkMemoryUsage = function () {
        var _this = this;
        requestAnimationFrame(function () {
            var hasAlarmed = false;
            var _a = window.performance.memory, jsHeapSizeLimit = _a.jsHeapSizeLimit, totalJSHeapSize = _a.totalJSHeapSize, usedJSHeapSize = _a.usedJSHeapSize;
            // Check if we've exceeded absolute memory limit
            if (usedJSHeapSize > _this.MAX_MEMORY_LIMIT) {
                hasAlarmed = true;
                var overage = usedJSHeapSize - _this.MAX_MEMORY_LIMIT;
                _this.errorTracking.captureMessage('Exceeded memory maximum limit', {
                    extra: { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize, overage: overage },
                });
            }
            // Check if we've exceeded relative memory limit for client
            if (usedJSHeapSize > _this.MAX_PERCENT_THRESHOLD / 100 * jsHeapSizeLimit) {
                hasAlarmed = true;
                _this.errorTracking.captureMessage('Memory usage exceeded', {
                    extra: {
                        jsHeapSizeLimit: jsHeapSizeLimit,
                        totalJSHeapSize: totalJSHeapSize,
                        usedJSHeapSize: usedJSHeapSize,
                        MAX_PERCENT_THRESHOLD: _this.MAX_PERCENT_THRESHOLD,
                    },
                });
            }
            // Only alert once
            if (!hasAlarmed) {
                setTimeout(function () { return _this.checkMemoryUsage(); }, _this.CHECK_INTERVAL);
            }
        });
    };
    MemoryLeakTrackingComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__error_tracking_service__["a" /* ErrorTracking */] }, { type: __WEBPACK_IMPORTED_MODULE_3__tracking_interface__["TrackingConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_2__tracking_config__["a" /* TRACKING_CONFIG */]] }] }]; };
    return MemoryLeakTrackingComponent;
}());

//# sourceMappingURL=memory-leak-tracking.component.js.map

/***/ }),

/***/ "Xszc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("Vf+6");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notificationsUserPreferencesReducer; });

var notificationsUserPreferencesReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'notificationsUserPreferences') {
                var _a = action.payload, data = _a.data, ref = _a.ref;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, transformNotificationsUserPreferences(data), ref);
            }
            return state;
        case 'API_POST_SUCCESS': {
            if (action.payload &&
                action.payload.ref.path[0] === 'notificationsUserPreferences') {
                var _b = action.payload, data = _b.data, ref = _b.ref;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, transformNotificationsUserPreferences(data), ref);
            }
            return state;
        }
        default:
            return state;
    }
};
function transformNotificationsUserPreferences(data) {
    return data.reduce(function (obj, setting) {
        obj[setting.channel] = {
            channel: setting.channel,
            name: setting.name,
            order: setting.order,
            enabled: setting.enabled,
            notify: setting.notify,
            header: setting.header,
            notificationType: setting.notificationType,
        };
        return obj;
    }, {});
}
//# sourceMappingURL=notification-preferences.reducer.js.map

/***/ }),

/***/ "YbRK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_performance_tracking_component_ngfactory__ = __webpack_require__("qntY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_navigation_performance_tracking_component__ = __webpack_require__("r0ba");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_service__ = __webpack_require__("7x6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_tracking_tracking_config__ = __webpack_require__("YgsG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_timing_tracking_component_ngfactory__ = __webpack_require__("tcVi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_shared_tracking_user_timing_tracking_component__ = __webpack_require__("AiWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__memory_leak_tracking_component_ngfactory__ = __webpack_require__("11eB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_shared_tracking_memory_leak_tracking_component__ = __webpack_require__("WuZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_shared_tracking_error_tracking_service__ = __webpack_require__("KAnv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__synthetic_performance_tracking_component_ngfactory__ = __webpack_require__("x6qj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_synthetic_performance_tracking_component__ = __webpack_require__("Lgsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ngx_cookie_src_cookie_service__ = __webpack_require__("9wrn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__app_shared_tracking_tracking_component__ = __webpack_require__("81Ll");
/* unused harmony export RenderType_TrackingComponent */
/* unused harmony export View_TrackingComponent_0 */
/* unused harmony export View_TrackingComponent_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackingComponentNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */














var styles_TrackingComponent = [];
var RenderType_TrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_22" /* ɵcrt */]({ encapsulation: 2,
    styles: styles_TrackingComponent, data: {} });
function View_TrackingComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_23" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_24" /* ɵted */](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 1, 'fl-navigation-performance-tracking', [], null, null, null, __WEBPACK_IMPORTED_MODULE_1__navigation_performance_tracking_component_ngfactory__["a" /* View_NavigationPerformanceTrackingComponent_0 */], __WEBPACK_IMPORTED_MODULE_1__navigation_performance_tracking_component_ngfactory__["b" /* RenderType_NavigationPerformanceTrackingComponent */])), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_26" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_navigation_performance_tracking_component__["a" /* NavigationPerformanceTrackingComponent */], [__WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_service__["a" /* Tracking */], __WEBPACK_IMPORTED_MODULE_4__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_24" /* ɵted */](null, ['\n    '])), (_l()(),
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 1, 'fl-user-timing-tracking', [], null, null, null, __WEBPACK_IMPORTED_MODULE_5__user_timing_tracking_component_ngfactory__["a" /* View_UserTimingTrackingComponent_0 */], __WEBPACK_IMPORTED_MODULE_5__user_timing_tracking_component_ngfactory__["b" /* RenderType_UserTimingTrackingComponent */])), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_26" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_6__app_shared_tracking_user_timing_tracking_component__["a" /* UserTimingTrackingComponent */], [__WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_service__["a" /* Tracking */]], null, null),
        (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_24" /* ɵted */](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 1, 'fl-memory-leak-tracking', [], null, null, null, __WEBPACK_IMPORTED_MODULE_7__memory_leak_tracking_component_ngfactory__["a" /* View_MemoryLeakTrackingComponent_0 */], __WEBPACK_IMPORTED_MODULE_7__memory_leak_tracking_component_ngfactory__["b" /* RenderType_MemoryLeakTrackingComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_26" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_8__app_shared_tracking_memory_leak_tracking_component__["a" /* MemoryLeakTrackingComponent */], [__WEBPACK_IMPORTED_MODULE_9__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */],
            __WEBPACK_IMPORTED_MODULE_4__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_24" /* ɵted */](null, ['\n    '])), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 1, 'fl-synthetic-performance-tracking', [], null, null, null, __WEBPACK_IMPORTED_MODULE_10__synthetic_performance_tracking_component_ngfactory__["a" /* View_SyntheticPerformanceTrackingComponent_0 */], __WEBPACK_IMPORTED_MODULE_10__synthetic_performance_tracking_component_ngfactory__["b" /* RenderType_SyntheticPerformanceTrackingComponent */])), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_26" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_synthetic_performance_tracking_component__["a" /* SyntheticPerformanceTrackingComponent */], [__WEBPACK_IMPORTED_MODULE_12_ngx_cookie_src_cookie_service__["a" /* CookieService */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["_15" /* Renderer2 */]], null, null), (_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_24" /* ɵted */](null, ['\n  ']))], function (_ck, _v) {
        _ck(_v, 2, 0);
        _ck(_v, 5, 0);
        _ck(_v, 8, 0);
        _ck(_v, 11, 0);
    }, null);
}
function View_TrackingComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_23" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 1, 'fl-tracking', [], null, null, null, View_TrackingComponent_0, RenderType_TrackingComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_26" /* ɵdid */](49152, null, 0, __WEBPACK_IMPORTED_MODULE_13__app_shared_tracking_tracking_component__["a" /* TrackingComponent */], [], null, null)], null, null);
}
var TrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_27" /* ɵccf */]('fl-tracking', __WEBPACK_IMPORTED_MODULE_13__app_shared_tracking_tracking_component__["a" /* TrackingComponent */], View_TrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdHJhY2tpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdHJhY2tpbmcuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy90cmFja2luZy5jb21wb25lbnQudHMuVHJhY2tpbmdDb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdHJhY2tpbmcuY29tcG9uZW50LnRzLlRyYWNraW5nQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPGZsLW5hdmlnYXRpb24tcGVyZm9ybWFuY2UtdHJhY2tpbmc+PC9mbC1uYXZpZ2F0aW9uLXBlcmZvcm1hbmNlLXRyYWNraW5nPlxuICAgIDxmbC11c2VyLXRpbWluZy10cmFja2luZz48L2ZsLXVzZXItdGltaW5nLXRyYWNraW5nPlxuICAgIDxmbC1tZW1vcnktbGVhay10cmFja2luZz48L2ZsLW1lbW9yeS1sZWFrLXRyYWNraW5nPlxuICAgIDxmbC1zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmc+PC9mbC1zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmc+XG4gICIsIjxmbC10cmFja2luZz48L2ZsLXRyYWNraW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBLDJDQUNJO01BQUE7TUFBQTswREFBQSxVQUFBO01BQUE7TUFBQSw2QkFBeUUsMkNBQ3pFO2FBQUE7VUFBQTttREFBQSxVQUFBO01BQUE7TUFBbUQsMkNBQ25EO1VBQUE7eUZBQUE7YUFBQTs0QkFBQSwrQkFBbUQ7VUFBQSxhQUNuRDtVQUFBOzhEQUFBLFVBQUE7VUFBQTtVQUFBLDZCQUF1RTs7SUFIdkU7SUFDQTtJQUNBO0lBQ0E7Ozs7b0JDSko7TUFBQTtrQ0FBQSxVQUFBO01BQUE7OzsifQ==
//# sourceMappingURL=tracking.component.ngfactory.js.map

/***/ }),

/***/ "YgsG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING_CONFIG; });

var TRACKING_CONFIG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* OpaqueToken */]('TrackingConfig');
//# sourceMappingURL=tracking.config.js.map

/***/ }),

/***/ "aKur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("Vf+6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_info_transformers__ = __webpack_require__("T09Y");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navigationUserInfoReducer; });


var navigationUserInfoReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationUserInfo') {
                var _a = action.payload, data = _a.data, ref = _a.ref;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["d" /* mergeEntity */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__user_info_transformers__["a" /* transformNavigationUserInfo */])(data), ref.path);
            }
            return state;
        default:
            return state;
    }
};
//# sourceMappingURL=user-info.reducer.js.map

/***/ }),

/***/ "b0JN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATASTORE_CONFIG; });

var DATASTORE_CONFIG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* OpaqueToken */]('DatastoreConfig');
//# sourceMappingURL=datastore.config.js.map

/***/ }),

/***/ "bUqa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notifications_notifications_reducer__ = __webpack_require__("wGeW");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__notifications_notifications_reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__project_feed_project_feed_reducer__ = __webpack_require__("+Tzi");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__project_feed_project_feed_reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__project_feed_project_feed_reducer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__project_feed_project_feed_reducer__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_balances_user_balances_reducer__ = __webpack_require__("yYxN");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__user_balances_user_balances_reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_info_user_info_reducer__ = __webpack_require__("aKur");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__user_info_user_info_reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__recent_projects_and_contests_recent_projects_and_contests_reducer__ = __webpack_require__("bw5M");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__recent_projects_and_contests_recent_projects_and_contests_reducer__["a"]; });





//# sourceMappingURL=navigation.reducer.js.map

/***/ }),

/***/ "bw5M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("Vf+6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recent_project_and_contests_transformers__ = __webpack_require__("0NQD");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navigationUserRecentProjectsAndContestsReducer; });


var navigationUserRecentProjectsAndContestsReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationUserRecentProjectsAndContests') {
                var ref = action.payload.ref;
                var data = action.payload.data;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__recent_project_and_contests_transformers__["a" /* transformUserRecentProjectsAndContests */])(data), ref);
            }
            return state;
        default:
            return state;
    }
};
//# sourceMappingURL=recent-projects-and-contests.reducer.js.map

/***/ }),

/***/ "e8+Z":
/***/ (function(module, exports) {

//# sourceMappingURL=auth.interface.js.map

/***/ }),

/***/ "fM0k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__environments_environment__ = __webpack_require__("p5Ee");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gendir_compat_compat_module_ngfactory__ = __webpack_require__("SD0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__ = __webpack_require__("fc+i");




if (__WEBPACK_IMPORTED_MODULE_1__environments_environment__["a" /* environment */].production) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["a" /* enableProdMode */])();
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__["a" /* platformBrowser */])().bootstrapModuleFactory(__WEBPACK_IMPORTED_MODULE_2__gendir_compat_compat_module_ngfactory__["a" /* CompatModuleNgFactory */]);
//# sourceMappingURL=main-compat.js.map

/***/ }),

/***/ "fgUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_combineLatest__ = __webpack_require__("vJ3t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_combineLatest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_combineLatest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_observable_concat__ = __webpack_require__("JSgX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_empty__ = __webpack_require__("hbO+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_observable_from__ = __webpack_require__("XL2q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_observable_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_interval__ = __webpack_require__("ACG2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_interval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_interval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_merge__ = __webpack_require__("JNTq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of__ = __webpack_require__("/zHi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_observable_throw__ = __webpack_require__("S7im");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_observable_throw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_observable_throw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_bufferTime__ = __webpack_require__("t8nJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_bufferTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_bufferTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_catch__ = __webpack_require__("xpf9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_combineLatest__ = __webpack_require__("6DBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_combineLatest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_combineLatest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_concat__ = __webpack_require__("R0J0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_add_operator_debounceTime__ = __webpack_require__("azLz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_add_operator_debounceTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_rxjs_add_operator_debounceTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_add_operator_distinctUntilChanged__ = __webpack_require__("MBEm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_add_operator_distinctUntilChanged___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_rxjs_add_operator_distinctUntilChanged__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_add_operator_do__ = __webpack_require__("eqpX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_add_operator_do___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_rxjs_add_operator_do__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_filter__ = __webpack_require__("gbhw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_first__ = __webpack_require__("ZQKz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_map__ = __webpack_require__("5v8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_mapTo__ = __webpack_require__("iwys");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_mapTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_mapTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_merge__ = __webpack_require__("ub06");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_mergeMap__ = __webpack_require__("RpuY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_add_operator_multicast__ = __webpack_require__("PatI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_add_operator_multicast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_rxjs_add_operator_multicast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_pluck__ = __webpack_require__("Ozq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_pluck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_pluck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs_add_operator_scan__ = __webpack_require__("6NKQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs_add_operator_scan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_rxjs_add_operator_scan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rxjs_add_operator_startWith__ = __webpack_require__("9jMf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rxjs_add_operator_startWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_rxjs_add_operator_startWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_rxjs_add_operator_switchMap__ = __webpack_require__("Pic8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_rxjs_add_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_rxjs_add_operator_switchMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_rxjs_add_operator_take__ = __webpack_require__("5uCp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_rxjs_add_operator_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_rxjs_add_operator_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_rxjs_add_operator_toPromise__ = __webpack_require__("82j9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_rxjs_add_operator_withLatestFrom__ = __webpack_require__("asHm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_rxjs_add_operator_withLatestFrom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_rxjs_add_operator_withLatestFrom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_rxjs_add_operator_delay__ = __webpack_require__("l3Q+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_rxjs_add_operator_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_rxjs_add_operator_delay__);
// See node_module/rxjs/Rxjs.js
// Import just the rxjs statics and operators needed for THIS app.
// Statics








// Operators






















//# sourceMappingURL=rxjs-operators.js.map

/***/ }),

/***/ "gsd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_cookie__ = __webpack_require__("0A7D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__ = __webpack_require__("0imh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_config__ = __webpack_require__("EURK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_interface__ = __webpack_require__("e8+Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__auth_interface__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Auth; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Auth = (function (_super) {
    __extends(Auth, _super);
    function Auth(authConfig, cookies) {
        var _this = _super.call(this, 1) || this;
        _this.authConfig = authConfig;
        _this.cookies = cookies;
        var uid = parseInt(_this.cookies.get(_this.authConfig.userIdCookie), 10);
        var token = _this.cookies.get(_this.authConfig.authHashCookie);
        _this.next({ uid: uid, token: token });
        return _this;
    }
    Auth.prototype.setState = function (uid, token) {
        this.cookies.put(this.authConfig.userIdCookie, uid.toString());
        this.cookies.put(this.authConfig.authHashCookie, token);
        this.next({ uid: uid, token: token });
    };
    /*login(): Promise<void> {
      // TODO
    }
  
    logout(): Promise<void> {
      // TODO
      // this.next({});
    }*/
    Auth.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_4__auth_interface__["AuthConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_3__auth_config__["a" /* AUTH_CONFIG */]] }] }, { type: __WEBPACK_IMPORTED_MODULE_1__shared_cookie__["a" /* CookieService */] }]; };
    return Auth;
}(__WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__["ReplaySubject"]));

//# sourceMappingURL=auth.service.js.map

/***/ }),

/***/ "l99c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_rxjs_operators__ = __webpack_require__("fgUf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__("o+tJ");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatComponent; });
// This allows us to load Angular components on legacy server-side pages.



var CompatComponent = (function () {
    function CompatComponent(injector, loader) {
        this.injector = injector;
        this.loader = loader;
    }
    CompatComponent.prototype.ngOnInit = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2__components__["a" /* components */].forEach(function (_a) {
            var selector = _a.selector, loadChildren = _a.loadChildren, component = _a.component;
            // Only bootstrap the components on the page
            if (document.getElementsByTagName(selector)[0]) {
                _this.loader
                    .load(loadChildren)
                    .then(function (ngModuleFactory) {
                    // NgModuleFactory
                    var componentFactory = ngModuleFactory
                        .create(_this.injector) // ngModuleRef
                        .componentFactoryResolver.resolveComponentFactory(component);
                    _this.entryPoint.createComponent(componentFactory);
                });
            }
        });
    };
    CompatComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["u" /* Injector */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Z" /* SkipSelf */] }] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["v" /* NgModuleFactoryLoader */] }]; };
    return CompatComponent;
}());

//# sourceMappingURL=compat.component.js.map

/***/ }),

/***/ "mAhR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("Vf+6");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onlineOfflineReducer; });

var onlineOfflineReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'WS_MESSAGE':
            if (action.payload.type === 'onlineOffline') {
                var data = action.payload.data;
                return Object.entries(data).reduce(function (s, _a) {
                    var userId = _a[0], status = _a[1];
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["d" /* mergeEntity */])(s, { status: status }, [
                        'onlineOffline',
                        userId,
                    ]);
                }, state);
            }
            return state;
        default:
            return state;
    }
};
//# sourceMappingURL=online-offline.reducer.js.map

/***/ }),

/***/ "mU2B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datastore__ = __webpack_require__("oZs6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datastore_config__ = __webpack_require__("b0JN");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatastoreModule; });


var DatastoreModule = (function () {
    function DatastoreModule() {
    }
    DatastoreModule.initialize = function (config) {
        return {
            ngModule: DatastoreModule,
            providers: [__WEBPACK_IMPORTED_MODULE_0__datastore__["a" /* Datastore */], { provide: __WEBPACK_IMPORTED_MODULE_1__datastore_config__["a" /* DATASTORE_CONFIG */], useValue: config }],
        };
    };
    return DatastoreModule;
}());

//# sourceMappingURL=datastore.module.js.map

/***/ }),

/***/ "o+tJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_tracking__ = __webpack_require__("s+Ea");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compat_navigation_component__ = __webpack_require__("J7eJ");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return components; });
// Add here the components that you want to bootstrap on PHP pages

// import { NavigationComponent } from '../app/navigation/navigation.component';

var components = [
    {
        selector: 'webapp-compat-tracking',
        loadChildren: 'app/@shared/tracking/tracking.module#TrackingModule',
        component: __WEBPACK_IMPORTED_MODULE_0__shared_tracking__["a" /* TrackingComponent */],
        path: 'hack_path_not_used',
    },
    {
        selector: 'webapp-compat-navigation',
        loadChildren: 'compat/compat-navigation.module#CompatNavigationModule',
        component: __WEBPACK_IMPORTED_MODULE_1__compat_navigation_component__["a" /* CompatNavigationComponent */],
        path: 'hack_path_not_used',
    },
];
//# sourceMappingURL=components.js.map

/***/ }),

/***/ "oZs6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("bKpL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject__ = __webpack_require__("0imh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("Vf+6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backend__ = __webpack_require__("LHQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_http_service__ = __webpack_require__("z11m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__websocket__ = __webpack_require__("2qMh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__list_observable__ = __webpack_require__("xeTY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__object_observable__ = __webpack_require__("QnNn");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Datastore; });








var Datastore = (function () {
    function Datastore(store, apiHttp, webSocketService) {
        this.store = store;
        this.apiHttp = apiHttp;
        this.webSocketService = webSocketService;
    }
    Datastore.prototype.list = function (arg1) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var optionsQuery = {};
        if (args.length && args[args.length - 1].query) {
            optionsQuery = args.pop().query;
        }
        var args$ = [arg1].concat(args).map(function (key) { return (key instanceof __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"] ? key : __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(key)); });
        var pathStream = __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].combineLatest(args$);
        var queryStream = __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].combineLatest([
            optionsQuery.limit instanceof __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"]
                ? optionsQuery.limit
                : __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(optionsQuery.limit),
            optionsQuery.offset instanceof __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"]
                ? optionsQuery.offset
                : __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(optionsQuery.offset),
        ], function (limit, offset) { return ({ limit: limit, offset: offset }); });
        var refStream = __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].combineLatest([pathStream, queryStream], function (path, query) { return ({ path: path, query: query }); })
            .multicast(function () { return new __WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject__["ReplaySubject"](1); })
            .refCount();
        var fetchStream = refStream.switchMap(function (ref) {
            var path = ref.path, query = ref.query;
            var fetch = __WEBPACK_IMPORTED_MODULE_3__backend__["a" /* backend */][path[0]].fetch;
            if (fetch) {
                return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(fetch(path[1], query))
                    .switchMap(function (config) { return _this.apiHttp.fetch(config, query); })
                    .do(function (data) {
                    _this.store.dispatch({
                        type: 'API_FETCH_SUCCESS',
                        payload: { data: data, ref: ref },
                    });
                })
                    .mapTo({ path: path, query: query });
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].empty();
            }
        });
        var websocketStream = this.webSocketService.fromServerStream.combineLatest(refStream, function (ws, ref) { return ref; });
        return new __WEBPACK_IMPORTED_MODULE_6__list_observable__["a" /* ListObservable */](refStream, this.apiHttp, this.store, __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].merge(refStream, fetchStream, websocketStream)
            .switchMap(function (_a) {
            var path = _a.path;
            return (_b = _this.store).pluck.apply(_b, path);
            var _b;
        })
            .distinctUntilChanged()
            .map(function (data) {
            if (data && data.lists) {
                return data.lists['default']
                    .slice(optionsQuery.offset || 0)
                    .map(function (id) { return data.entities[id]; });
            }
            else {
                return [];
            }
        }));
    };
    Datastore.prototype.object = function (arg1) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var args$ = [arg1].concat(args).map(function (key) { return (key instanceof __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"] ? key : __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(key)); });
        var refStream = __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].combineLatest(args$)
            .map(function (path) { return ({ path: path }); })
            .multicast(function () { return new __WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject__["ReplaySubject"](1); })
            .refCount();
        var fetchStream = refStream.switchMap(function (_a) {
            var path = _a.path;
            if (__WEBPACK_IMPORTED_MODULE_3__backend__["a" /* backend */][path[0]].fetch) {
                return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__backend__["a" /* backend */][path[0]].fetch(path[1]))
                    .switchMap(function (config) { return _this.apiHttp.fetch(config); })
                    .do(function (data) {
                    _this.store.dispatch({
                        type: 'API_FETCH_SUCCESS',
                        payload: { data: data, ref: { path: path } },
                    });
                })
                    .mapTo({ path: path });
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].empty();
            }
        });
        var subscriptionStream = arg1 === 'onlineOffline'
            ? this.webSocketService
                .subscribeOnlineOffline(args$[1])
                .combineLatest(refStream, function (ss, ref) { return ref; })
            : refStream;
        var websocketStream = this.webSocketService.fromServerStream.combineLatest(refStream, function (ws, ref) { return ref; });
        return new __WEBPACK_IMPORTED_MODULE_7__object_observable__["a" /* ObjectObservable */](refStream, this.apiHttp, this.store, __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].merge(refStream, fetchStream, subscriptionStream, websocketStream)
            .switchMap(function (_a) {
            var path = _a.path;
            return (_b = _this.store).pluck.apply(_b, path);
            var _b;
        })
            .distinctUntilChanged()
            .filter(function (obj) { return obj !== undefined; }));
    };
    Datastore.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* Store */] }, { type: __WEBPACK_IMPORTED_MODULE_4__api_http_service__["a" /* ApiHttp */] }, { type: __WEBPACK_IMPORTED_MODULE_5__websocket__["a" /* WebSocketService */] }]; };
    return Datastore;
}());

//# sourceMappingURL=datastore.js.map

/***/ }),

/***/ "p5Ee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return environment; });
var environment = {
    production: true,
    gafBaseUrl: 'https://www.freelancer.com',
    authConfig: {
        baseUrl: 'https://www.freelancer.com/auth',
        authHashCookie: 'GETAFREE_AUTH_HASH_V2',
        userIdCookie: 'GETAFREE_USER_ID',
    },
    datastoreConfig: {
        apiBaseUrl: 'https://www.freelancer.com/api',
        ajaxBaseUrl: 'https://www.freelancer.com/ajax-api',
        webSocketUrl: 'https://notifications.freelancer.com',
    },
    trackingConfig: {
        trackingEndpoint: 'https://t.freelancer.com/0px.gif',
        sessionCookie: '_tracking_session',
        navigationPerformanceSamplingRate: 1,
        enableErrorTracking: true,
        sentryDsn: 'https://89961363a0f642558f5fedad5195eb89@sentry.io/85230',
        gitRevision: '99ef035f96d',
        buildDate: 'Tue Jul 11 2017 08:58:34 GMT-0400 (EDT)',
    },
    billingConfig: {
        baseUrl: 'https://api.flnbln.net',
    },
    facebookAppId: '',
    languageCookie: 'GETAFREE_LANGUAGE',
};
//# sourceMappingURL=environment.js.map

/***/ }),

/***/ "qntY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_navigation_performance_tracking_component__ = __webpack_require__("r0ba");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_tracking_service__ = __webpack_require__("7x6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_config__ = __webpack_require__("YgsG");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_NavigationPerformanceTrackingComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_NavigationPerformanceTrackingComponent_0;
/* unused harmony export View_NavigationPerformanceTrackingComponent_Host_0 */
/* unused harmony export NavigationPerformanceTrackingComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_NavigationPerformanceTrackingComponent = [];
var RenderType_NavigationPerformanceTrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_22" /* ɵcrt */]({ encapsulation: 2,
    styles: styles_NavigationPerformanceTrackingComponent, data: {} });
function View_NavigationPerformanceTrackingComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_23" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 0, null, null, null, null, null, null, null))], null, null);
}
function View_NavigationPerformanceTrackingComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_23" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 1, 'fl-navigation-performance-tracking', [], null, null, null, View_NavigationPerformanceTrackingComponent_0, RenderType_NavigationPerformanceTrackingComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_26" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_navigation_performance_tracking_component__["a" /* NavigationPerformanceTrackingComponent */], [__WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_tracking_service__["a" /* Tracking */], __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var NavigationPerformanceTrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_27" /* ɵccf */]('fl-navigation-performance-tracking', __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_navigation_performance_tracking_component__["a" /* NavigationPerformanceTrackingComponent */], View_NavigationPerformanceTrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy9uYXZpZ2F0aW9uLXBlcmZvcm1hbmNlLXRyYWNraW5nLmNvbXBvbmVudC50cyIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMuTmF2aWdhdGlvblBlcmZvcm1hbmNlVHJhY2tpbmdDb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMuTmF2aWdhdGlvblBlcmZvcm1hbmNlVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC1uYXZpZ2F0aW9uLXBlcmZvcm1hbmNlLXRyYWNraW5nPjwvZmwtbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7Ozs7b0JDQUE7TUFBQTt1REFBQSxVQUFBO01BQUE7TUFBQTtJQUFBOzs7OzsifQ==
//# sourceMappingURL=navigation-performance-tracking.component.ngfactory.js.map

/***/ }),

/***/ "qtrl":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"app/@shared/tracking/tracking.module.ngfactory": [
		"Bn6G",
		1
	],
	"compat/compat-navigation.module.ngfactory": [
		"lxkG",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "qtrl";

/***/ }),

/***/ "r0ba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_boomerang_boomerang_js__ = __webpack_require__("EZXR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_boomerang_boomerang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_boomerang_boomerang_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_boomerang_plugins_auto_xhr_js__ = __webpack_require__("Kpyf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_boomerang_plugins_auto_xhr_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_boomerang_plugins_auto_xhr_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_boomerang_plugins_spa_js__ = __webpack_require__("DOiN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_boomerang_plugins_spa_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_boomerang_plugins_spa_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_boomerang_plugins_history_js__ = __webpack_require__("yQs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_boomerang_plugins_history_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_boomerang_plugins_history_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_boomerang_plugins_rt_js__ = __webpack_require__("RKDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_boomerang_plugins_rt_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_boomerang_plugins_rt_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_boomerang_plugins_navtiming_js__ = __webpack_require__("i/aF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_boomerang_plugins_navtiming_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_boomerang_plugins_navtiming_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_boomerang_plugins_restiming_js__ = __webpack_require__("OWwY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_boomerang_plugins_restiming_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_boomerang_plugins_restiming_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tracking_service__ = __webpack_require__("7x6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tracking_config__ = __webpack_require__("YgsG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tracking_interface__ = __webpack_require__("Ebf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tracking_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__tracking_interface__);
/* unused harmony export NavigationPerformanceCategory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationPerformanceTrackingComponent; });











var NavigationPerformanceCategory;
(function (NavigationPerformanceCategory) {
    NavigationPerformanceCategory[NavigationPerformanceCategory["INITIAL_PAGE_LOAD"] = 0] = "INITIAL_PAGE_LOAD";
    NavigationPerformanceCategory[NavigationPerformanceCategory["ROUTE_CHANGE"] = 1] = "ROUTE_CHANGE";
})(NavigationPerformanceCategory || (NavigationPerformanceCategory = {}));
var NavigationPerformanceTrackingComponent = (function () {
    function NavigationPerformanceTrackingComponent(t, config) {
        this.t = t;
        this.config = config;
    }
    NavigationPerformanceTrackingComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (Math.random() > this.config.navigationPerformanceSamplingRate) {
            return;
        }
        // Whenever Boomerang intercepts an XHR request, it will check if that
        // request matches anything in the exclude list, and if it does, Boomerang
        // will not instrument, time, or beacon that request
        BOOMR.xhr_excludes = {
            't.freelancer.com': true,
            'googleads.g.doubleclick.net': true,
            'static.doubleclick.net': true,
            'www.googletagmanager.com': true,
            'www.google.com': true,
            'connect.facebook.net': true,
        };
        BOOMR.init({
            log: function (message, level, source) {
                if (level === 'error') {
                    console.error(message, source);
                }
            },
            autorun: false,
            History: {
                auto: true,
                enabled: true,
            },
        });
        // boomerang as its own error handling thing
        BOOMR.plugins.Errors = {
            is_supported: function () {
                return true;
            },
            is_complete: function () {
                return true;
            },
            send: function (err) {
                throw err;
            },
        };
        var previousUrl;
        BOOMR.subscribe('before_beacon', function (e) {
            if (e['http.initiator'] !== 'spa_hard' && e['http.initiator'] !== 'spa') {
                return;
            }
            // Previous URL
            if (!previousUrl) {
                previousUrl = e.r;
            }
            var data = {
                category: e['http.initiator'] !== 'spa'
                    ? NavigationPerformanceCategory.INITIAL_PAGE_LOAD
                    : NavigationPerformanceCategory.ROUTE_CHANGE,
                totalTime: e.t_done,
                backendTime: e.t_resp,
                frontendTime: e.t_page,
                previousUrl: previousUrl,
                resourceTimings: e.restiming,
            };
            // NavigationTimings
            if (e.nt_nav_st) {
                Object.assign(data, {
                    // PerformanceNavigation
                    redirectCount: e.nt_red_cnt,
                    navigationType: e.nt_nav_type,
                    // PerformanceTiming
                    navigationStart: e.nt_nav_st,
                    redirectStart: e.nt_red_st,
                    redirectEnd: e.nt_red_end,
                    fetchStart: e.nt_fet_st,
                    domainLookupStart: e.nt_dns_st,
                    domainLookupEnd: e.nt_dns_end,
                    connectStart: e.nt_con_st,
                    connectEnd: e.nt_con_end,
                    requestStart: e.nt_req_st,
                    responseStart: e.nt_res_st,
                    responseEnd: e.nt_res_end,
                    domLoading: e.nt_domloading,
                    domInteractive: e.nt_domint,
                    domContentLoadedEventStart: e.nt_domcontloaded_st,
                    domContentLoadedEventEnd: e.nt_domcontloaded_end,
                    domComplete: e.nt_domcomp,
                    loadEventStart: e.nt_load_st,
                    loadEventEnd: e.nt_load_end,
                    unloadEventStart: e.nt_unload_st,
                    unloadEventEnd: e.nt_unload_end,
                });
                if (e.nt_first_paint) {
                    // First paint
                    Object.assign(data, {
                        firstPaint: e.nt_first_paint * 1000,
                    });
                }
            }
            // Fire the event
            _this.t.track('page_performance_timings', data);
            // Clear the Resource Timings Buffer
            if (window.performance && window.performance.clearResourceTimings) {
                window.performance.clearResourceTimings();
            }
            previousUrl = window.location.href;
            // Notify boomerang that we've fired the beacon
            BOOMR.fireEvent('onbeacon', data);
        });
    };
    NavigationPerformanceTrackingComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_8__tracking_service__["a" /* Tracking */] }, { type: __WEBPACK_IMPORTED_MODULE_10__tracking_interface__["TrackingConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_9__tracking_config__["a" /* TRACKING_CONFIG */]] }] }]; };
    return NavigationPerformanceTrackingComponent;
}());

//# sourceMappingURL=navigation-performance-tracking.component.js.map

/***/ }),

/***/ "s+Ea":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracking_module__ = __webpack_require__("JTSy");
/* unused harmony reexport TrackingModule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracking_component__ = __webpack_require__("81Ll");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__tracking_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__custom_error_handler_service__ = __webpack_require__("FXv2");
/* unused harmony reexport CustomErrorHandler */



//# sourceMappingURL=index.js.map

/***/ }),

/***/ "t1Sn":
/***/ (function(module, exports) {

//# sourceMappingURL=datastore.interface.js.map

/***/ }),

/***/ "tcVi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_user_timing_tracking_component__ = __webpack_require__("AiWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_tracking_service__ = __webpack_require__("7x6H");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_UserTimingTrackingComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_UserTimingTrackingComponent_0;
/* unused harmony export View_UserTimingTrackingComponent_Host_0 */
/* unused harmony export UserTimingTrackingComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_UserTimingTrackingComponent = [];
var RenderType_UserTimingTrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_22" /* ɵcrt */]({ encapsulation: 2,
    styles: styles_UserTimingTrackingComponent, data: {} });
function View_UserTimingTrackingComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_23" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 0, null, null, null, null, null, null, null))], null, null);
}
function View_UserTimingTrackingComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_23" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 1, 'fl-user-timing-tracking', [], null, null, null, View_UserTimingTrackingComponent_0, RenderType_UserTimingTrackingComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_26" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_user_timing_tracking_component__["a" /* UserTimingTrackingComponent */], [__WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_tracking_service__["a" /* Tracking */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var UserTimingTrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_27" /* ɵccf */]('fl-user-timing-tracking', __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_user_timing_tracking_component__["a" /* UserTimingTrackingComponent */], View_UserTimingTrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdXNlci10aW1pbmctdHJhY2tpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdXNlci10aW1pbmctdHJhY2tpbmcuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy91c2VyLXRpbWluZy10cmFja2luZy5jb21wb25lbnQudHMuVXNlclRpbWluZ1RyYWNraW5nQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL3VzZXItdGltaW5nLXRyYWNraW5nLmNvbXBvbmVudC50cy5Vc2VyVGltaW5nVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC11c2VyLXRpbWluZy10cmFja2luZz48L2ZsLXVzZXItdGltaW5nLXRyYWNraW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBOzs7O29CQ0FBO01BQUE7NENBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=
//# sourceMappingURL=user-timing-tracking.component.ngfactory.js.map

/***/ }),

/***/ "tmEA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformUser;
/* unused harmony export transformUserImage */
/* harmony export (immutable) */ __webpack_exports__["b"] = transformUserBalances;
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function transformUser(user) {
    return {
        id: user.id,
        avatar: transformUserImage(user.avatar),
        avatarLarge: transformUserImage(user.avatar_large),
        username: user.username,
        displayName: user.display_name,
        role: user.role,
        profileUrl: "/u/" + user.username + ".html",
    };
}
function transformUserImage(image) {
    return image !== '/img/unknown.png' ? image : undefined;
}
function transformUserBalances(user) {
    return user.account_balances.balances.reduce(function (acc, balance) {
        return (__assign({}, acc, (_a = {}, _a[balance.currency.id] = __assign({}, balance, { primary: balance.currency.code === user.primary_currency.code }), _a)));
        var _a;
    }, {});
}
//# sourceMappingURL=user.reducer.js.map

/***/ }),

/***/ "wGeW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("Vf+6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notification_transformers__ = __webpack_require__("yeSI");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navigationNotificationsReducer; });


var navigationNotificationsReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationNotifications') {
                var data = action.payload.data;
                var ref = action.payload.ref;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__notification_transformers__["a" /* transformNavigationNotifications */])(data.hits.hits.map(function (hit) { return hit._source; })), ref);
            }
            return state;
        case 'WS_MESSAGE':
            var userId = action.payload.userId;
            switch (action.payload.type) {
                case 'award':
                case 'bid':
                case 'contestAwardedToEmployer':
                case 'contestEntry':
                case 'contestPCBNotification':
                case 'draftContest':
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__notification_transformers__["a" /* transformNavigationNotifications */])([action.payload]), {
                        path: ['navigationNotifications', userId],
                    });
                // I'm not sure if the newsfeed has these types. If they are possible then they should be added to NewsfeedApiResponseEntry.
                case 'awardBadge':
                case 'awardCredit':
                case 'awardMilestoneReminder':
                case 'awardReminder':
                case 'awardXp':
                case 'completed':
                case 'contactRequestReceived':
                case 'contest':
                case 'contestAwardedToFreelancer':
                case 'contestEntryBoughtToEmployer':
                case 'contestEntryBoughtToFreelancer':
                case 'contestPCBNotificationFullView':
                case 'createMilestone':
                case 'denyed':
                case 'failingProject':
                case 'highLtvAnnualDiscount':
                case 'inviteToContest':
                case 'inviteUserBid':
                case 'invoiceRequested':
                case 'levelup':
                case 'notifyfollower':
                case 'project':
                case 'projectRecruiter':
                case 'quickHireProject':
                case 'releaseMilestone':
                case 'requestEndProject':
                case 'requestMilestone':
                case 'requestToRelease':
                case 'serviceApproved':
                case 'serviceProjectEndingSeller':
                case 'serviceProjectPostedSeller':
                case 'serviceRejected':
                case 'signUpFreeTrialUpsell':
                case 'sitesBinCreated':
                case 'sitesHandOverMessageSent':
                case 'sitesListingStatusChanged':
                case 'sitesMessageSent':
                case 'sitesOfferCreated':
                case 'upsellCrowdsourceFinding':
                case 'xpContest':
                    return state;
                default:
                    return state;
            }
        default:
            return state;
    }
};
//# sourceMappingURL=notifications.reducer.js.map

/***/ }),

/***/ "x6qj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_synthetic_performance_tracking_component__ = __webpack_require__("Lgsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngx_cookie_src_cookie_service__ = __webpack_require__("9wrn");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_SyntheticPerformanceTrackingComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_SyntheticPerformanceTrackingComponent_0;
/* unused harmony export View_SyntheticPerformanceTrackingComponent_Host_0 */
/* unused harmony export SyntheticPerformanceTrackingComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_SyntheticPerformanceTrackingComponent = [];
var RenderType_SyntheticPerformanceTrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_22" /* ɵcrt */]({ encapsulation: 2,
    styles: styles_SyntheticPerformanceTrackingComponent, data: {} });
function View_SyntheticPerformanceTrackingComponent_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_23" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 0, null, null, null, null, null, null, null))], null, null);
}
function View_SyntheticPerformanceTrackingComponent_Host_0(_l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_23" /* ɵvid */](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_25" /* ɵeld */](0, null, null, 1, 'fl-synthetic-performance-tracking', [], null, null, null, View_SyntheticPerformanceTrackingComponent_0, RenderType_SyntheticPerformanceTrackingComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_26" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_synthetic_performance_tracking_component__["a" /* SyntheticPerformanceTrackingComponent */], [__WEBPACK_IMPORTED_MODULE_2_ngx_cookie_src_cookie_service__["a" /* CookieService */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["_15" /* Renderer2 */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var SyntheticPerformanceTrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_27" /* ɵccf */]('fl-synthetic-performance-tracking', __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_synthetic_performance_tracking_component__["a" /* SyntheticPerformanceTrackingComponent */], View_SyntheticPerformanceTrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvc3ludGhldGljLXBlcmZvcm1hbmNlLXRyYWNraW5nLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL3N5bnRoZXRpYy1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL3N5bnRoZXRpYy1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMuU3ludGhldGljUGVyZm9ybWFuY2VUcmFja2luZ0NvbXBvbmVudC5odG1sIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy9zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmcuY29tcG9uZW50LnRzLlN5bnRoZXRpY1BlcmZvcm1hbmNlVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC1zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmc+PC9mbC1zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmc+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7Ozs7b0JDQUE7TUFBQTtzREFBQSxVQUFBO01BQUE7TUFBQTtJQUFBOzs7OzsifQ==
//# sourceMappingURL=synthetic-performance-tracking.component.ngfactory.js.map

/***/ }),

/***/ "xeTY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("bKpL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backend__ = __webpack_require__("LHQ0");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListObservable; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ListObservable = (function (_super) {
    __extends(ListObservable, _super);
    function ListObservable(ref$, apiHttp, store, source) {
        var _this = _super.call(this) || this;
        _this.ref$ = ref$;
        _this.apiHttp = apiHttp;
        _this.store = store;
        _this.source = source;
        return _this;
    }
    ListObservable.prototype.lift = function (operator) {
        var observable = new ListObservable(this.ref$, this.apiHttp, this.store, this);
        observable.operator = operator;
        return observable;
    };
    ListObservable.prototype.push = function (body) {
        var _this = this;
        return this.ref$
            .take(1)
            .switchMap(function (ref) {
            var path = ref.path, query = ref.query;
            var post = __WEBPACK_IMPORTED_MODULE_1__backend__["a" /* backend */][path[0]].post;
            if (post) {
                return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(post(path[1]))
                    .do(function (data) {
                    return _this.store.dispatch({
                        type: 'API_POST',
                        payload: { data: data, ref: ref },
                    });
                })
                    .switchMap(function (config) { return _this.apiHttp.post(config, body); })
                    .do(function (data) {
                    return _this.store.dispatch({
                        type: 'API_POST_SUCCESS',
                        payload: { data: data, ref: ref },
                    });
                });
            }
        })
            .mapTo(true);
    };
    return ListObservable;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"]));

//# sourceMappingURL=list-observable.js.map

/***/ }),

/***/ "ySlr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("Vf+6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_user_reducer__ = __webpack_require__("tmEA");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return threadReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return threadUnreadCountReducer; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var threadReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload && action.payload.ref.path[0] === 'threads') {
                var ref = action.payload.ref;
                // action.payload.ref.path[1] is the user. Use it for now.
                var selfId_1 = Number(ref.path[1]);
                var data = action.payload.data;
                // Denormalize the Thread API response
                var contextDetails_1 = data.context_details;
                var users_1 = data.users;
                var threads = data.threads.reduce(
                // FIXME: thread: any inference needs to go. ContextApi is incorrect.
                function (acc, thread) {
                    var context = __assign({}, thread.thread.context);
                    if (context) {
                        if (context.type === 'project') {
                            context.project = contextDetails_1.projects[context.id];
                        }
                        else if (context.type === 'contest') {
                            context.contest = contextDetails_1.contests[context.id];
                        }
                        context.id = undefined;
                    }
                    // FIXME: The explicit type here is because thread is still an any.
                    var members = thread.thread.members.map(function (memberId) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__user_user_reducer__["a" /* transformUser */])(users_1[memberId]); });
                    var owner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__user_user_reducer__["a" /* transformUser */])(users_1[thread.thread.owner]);
                    var otherMembers = members.filter(function (member) { return member.id !== selfId_1; });
                    var title = '';
                    var subtitle = '';
                    var membersString = thread.thread.members
                        .filter(function (userId) { return userId !== selfId_1; })
                        .map(function (userId) { return users_1[userId].username; })
                        .join(', ');
                    title = membersString;
                    if (thread.thread.context &&
                        thread.thread.context.type === 'project' &&
                        contextDetails_1.projects[thread.thread.context.id]) {
                        title = contextDetails_1.projects[thread.thread.context.id].title;
                        subtitle = membersString;
                    }
                    var threadInner = __assign({}, thread.thread, { context: context,
                        members: members,
                        owner: owner,
                        otherMembers: otherMembers,
                        title: title,
                        subtitle: subtitle });
                    var messages = thread.messages &&
                        thread.messages.map(function (message) {
                            return __assign({}, message, { fromUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__user_user_reducer__["a" /* transformUser */])(users_1[message.from_user]) });
                        });
                    acc[thread.id] = __assign({}, thread, { thread: threadInner, time_read: thread.time_read * 1000, time_updated: thread.time_updated * 1000, messages: messages });
                    return acc;
                }, {});
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, threads, ref);
            }
            return state;
        /*case 'WEBSOCKET_LOAD_SUCCESS':
          const threadId: any = action.payload.thread_id;
          let newThreads: any = {};
          const thread: any = state[threadId];
          if (!thread) {
            return state;
          }
          const now = Date.now();
          const newTimeUpdated: any = { time_updated: now };
          newThreads[threadId] = Object.assign({}, thread, newTimeUpdated);
          return Object.assign({}, state, newThreads);*/
        default:
            return state;
    }
};
var threadUnreadCountReducer = function (state, action) {
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'threadUnreadCount') {
                var _a = action.payload, data = _a.data, ref = _a.ref;
                //  return mergeEntities(state, data.unread_thread_count, ref);
                return state;
            }
            return state;
        default:
            return state;
    }
};
//# sourceMappingURL=thread.reducer.js.map

/***/ }),

/***/ "yYxN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("Vf+6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_user_reducer__ = __webpack_require__("tmEA");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navigationUserBalancesReducer; });


var navigationUserBalancesReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationUserBalances') {
                var ref = action.payload.ref;
                var data = action.payload.data;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__user_user_reducer__["b" /* transformUserBalances */])(data), ref);
            }
            return state;
        default:
            return state;
    }
};
//# sourceMappingURL=user-balances.reducer.js.map

/***/ }),

/***/ "yeSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformNavigationNotifications;
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function transformNavigationNotifications(entries) {
    return entries.reduce(function (acc, entry) {
        var id = entry.type === 'contestAwardedToEmployer'
            ? entry.data.entry_id
            : entry.type === 'draftContest' ? entry.data.contestId : entry.data.id;
        return __assign({}, acc, (_a = {}, _a[entry.type + "-" + id] = transformNavigationNotification(entry), _a));
        var _a;
    }, {});
}
function stringToNumber(x) {
    return x ? Number(x) : undefined;
}
function transformNavigationNotification(entry) {
    // TODO: Standardise linkUrl. There's things like contestUrl for example.
    switch (entry.type) {
        case 'project':
            var exchangerate = Number(entry.data.exchangerate);
            var minBudget = stringToNumber(entry.data.minbudget);
            var maxBudget = stringToNumber(entry.data.maxbudget);
            return {
                type: entry.type,
                data: {
                    address: entry.data.address,
                    appendedDescr: entry.data.appended_descr,
                    currency: entry.data.currency,
                    currencyCode: entry.data.currencyCode,
                    exchangerate: entry.data.exchangerate,
                    featured: entry.data.featured,
                    freeBidUntil: entry.data.free_bid_until,
                    fulltime: entry.data.fulltime,
                    hideBids: entry.data.hideBids,
                    id: entry.data.id,
                    imgUrl: entry.data.imgUrl,
                    isLocal: entry.data.isLocal,
                    isMinimallyPostedProject: entry.data.isMinimallyPostedProject,
                    isTest: entry.data.isTest,
                    jobs: entry.data.jobs,
                    jobString: entry.data.jobString,
                    linkUrl: entry.data.linkUrl,
                    maxBudget: maxBudget,
                    minBudget: minBudget,
                    minimallyPostedProjectBudgetSet: entry.data.minimallyPostedProjectBudgetSet,
                    nonPublic: entry.data.nonpublic,
                    projIsHourly: entry.data.projIsHourly,
                    publicName: entry.data.publicName,
                    showBudgetMinimallyPostedProject: entry.data.showBudgetMinimallyPostedProject,
                    submitDate: entry.data.submitDate,
                    text: entry.data.text,
                    time: entry.data.time,
                    title: entry.data.title,
                    usdMaxbudget: maxBudget
                        ? Math.round(maxBudget * exchangerate)
                        : undefined,
                    usdMinbudget: minBudget
                        ? Math.round(minBudget * exchangerate)
                        : undefined,
                    userId: entry.data.userId,
                    userName: entry.data.userName,
                },
            };
        case 'draftContest': {
            return {
                type: entry.type,
                data: __assign({}, entry.data, { linkUrl: entry.data.contestUrl }),
            };
        }
        default:
            return entry;
    }
}
//# sourceMappingURL=notification.transformers.js.map

/***/ }),

/***/ "z11m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_auth__ = __webpack_require__("W4ip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__ = __webpack_require__("bKpL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datastore_config__ = __webpack_require__("b0JN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datastore_interface__ = __webpack_require__("t1Sn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datastore_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__datastore_interface__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiHttp; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var ApiHttp = (function (_super) {
    __extends(ApiHttp, _super);
    function ApiHttp(backend, defaultOptions, auth, datastoreConfig) {
        var _this = _super.call(this, backend, defaultOptions) || this;
        _this.auth = auth;
        _this.datastoreConfig = datastoreConfig;
        return _this;
    }
    ApiHttp.prototype.fetch = function (config, pagination) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__["Observable"].of(config)
            .withLatestFrom(this.authHeader())
            .switchMap(function (_a) {
            var newConfig = _a[0], authHeader = _a[1];
            var baseUrl = newConfig.isGaf
                ? _this.datastoreConfig.ajaxBaseUrl
                : _this.datastoreConfig.apiBaseUrl;
            var search = pagination
                ? __assign({}, newConfig.params, { limit: pagination.limit, offset: pagination.offset }) : newConfig.params;
            return _super.prototype.get.call(_this, baseUrl + "/" + newConfig.endpoint, {
                headers: authHeader,
                search: _this.serialize(search),
            });
        })
            .map(function (res) { return res.json(); })
            .map(function (body) { return body.result; });
    };
    ApiHttp.prototype.post = function (config, payload) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__["Observable"].of(config)
            .withLatestFrom(this.authHeader(), function (c, h) { return [c, h]; })
            .switchMap(function (_a) {
            var newConfig = _a[0], authHeader = _a[1];
            var baseUrl = newConfig.isGaf
                ? _this.datastoreConfig.ajaxBaseUrl
                : _this.datastoreConfig.apiBaseUrl;
            return _super.prototype.post.call(_this, baseUrl + "/" + newConfig.endpoint, _this.serialize(__assign({}, payload, newConfig.params)), {
                headers: authHeader,
            });
        })
            .map(function (res) { return res.json(); })
            .map(function (body) { return body.result; });
    };
    ApiHttp.prototype.authHeader = function () {
        return this.auth.map(function (_a) {
            var uid = _a.uid, token = _a.token;
            return new __WEBPACK_IMPORTED_MODULE_1__angular_http__["k" /* Headers */]({ 'freelancer-auth-v2': uid + ";" + token });
        });
    };
    ApiHttp.prototype.serialize = function (obj) {
        var params = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["l" /* URLSearchParams */]();
        Object.entries(obj).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (typeof value === 'string') {
                params.set(key, value);
            }
            else if (typeof value === 'number') {
                params.set(key, String(value));
            }
            else if (Array.isArray(value)) {
                // This type casting shouldn't be necessary but is because of a TS bug.
                // https://github.com/Microsoft/TypeScript/issues/15315
                // https://github.com/Microsoft/TypeScript/issues/7294
                // Our backend expects arrays foo=[1,2] to be encoded as foo[]=1&foo[]=2
                value.forEach(function (v) {
                    params.append(key + "[]", String(v));
                });
            }
        });
        params.set('compact', 'true');
        return params;
    };
    ApiHttp.prototype.handleException = function (error) {
        // In a real world app, we might use a remote logging infrastructure
        var errMsg;
        if (error instanceof __WEBPACK_IMPORTED_MODULE_1__angular_http__["m" /* Response */]) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__["Observable"].throw(errMsg);
    };
    ApiHttp.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* XHRBackend */] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_http__["f" /* RequestOptions */] }, { type: __WEBPACK_IMPORTED_MODULE_2__shared_auth__["a" /* Auth */] }, { type: __WEBPACK_IMPORTED_MODULE_5__datastore_interface__["DatastoreConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_4__datastore_config__["a" /* DATASTORE_CONFIG */]] }] }]; };
    return ApiHttp;
}(__WEBPACK_IMPORTED_MODULE_1__angular_http__["h" /* Http */]));

//# sourceMappingURL=api-http.service.js.map

/***/ }),

/***/ "zHYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export transformNavigationProjectFeedItem */
/* harmony export (immutable) */ __webpack_exports__["a"] = transformNavigationProjectFeedItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = transformNavigationProjectFeedWS;
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// This takes an API response and transforms it into a NavigationProjectFeed object
function transformNavigationProjectFeedItem(item) {
    return _a = {},
        _a[item.type + "-" + item.id] = {
            id: item.id,
            appendedDescr: item.appended_descr,
            currency: item.currency,
            currencyCode: item.currencyCode,
            exchangerate: item.exchangerate,
            featured: item.featured,
            freeBidUntil: item.free_bid_until,
            fulltime: item.fulltime,
            // hidebids: item.hidebids,
            imgUrl: item.imgUrl,
            isMinimallyPostedProject: item.isMinimallyPostedProject,
            jobs: item.jobs.map(function (job) { return Number(job); }),
            jobString: item.jobString,
            linkUrl: item.linkUrl,
            maxbudget: Number(item.maxbudget),
            minbudget: Number(item.minbudget),
            minimallyPostedProjectBudgetSet: item.minimallyPostedProjectBudgetSet,
            nonpublic: item.nonpublic,
            projIsHourly: item.projIsHourly,
            showBudgetMinimallyPostedProject: item.showBudgetMinimallyPostedProject,
            submitDate: item.submitDate,
            text: item.text,
            time: item.time * 1000,
            title: item.title,
            type: item.type,
            userId: Number(item.userId),
            userName: item.userName,
        },
        _a;
    var _a;
}
// This takes an API response and transforms it into a NavigationProjectFeed object
function transformNavigationProjectFeedItems(items) {
    if (items) {
        return items.reduce(function (acc, item) { return (__assign({}, acc, transformNavigationProjectFeedItem(item))); }, {});
    }
    return {};
}
function transformNavigationProjectFeedWS(item) {
    return _a = {},
        _a["project-" + item.id] = {
            id: item.id,
            appendedDescr: item.appended_descr,
            currency: item.currency,
            currencyCode: item.currencyCode,
            exchangerate: item.exchangerate,
            featured: item.featured,
            freeBidUntil: item.free_bid_until,
            fulltime: item.fulltime,
            imgUrl: item.imgUrl,
            isMinimallyPostedProject: item.isMinimallyPostedProject,
            jobs: item.jobs.map(function (job) { return Number(job); }),
            jobString: item.jobString,
            linkUrl: item.linkUrl,
            maxbudget: Number(item.maxbudget),
            minbudget: Number(item.minbudget),
            minimallyPostedProjectBudgetSet: item.minimallyPostedProjectBudgetSet,
            nonpublic: item.nonpublic,
            projIsHourly: item.projIsHourly,
            showBudgetMinimallyPostedProject: item.showBudgetMinimallyPostedProject,
            submitDate: item.submitDate,
            text: item.text,
            time: item.time * 1000,
            title: item.title,
            type: 'project',
            userId: Number(item.userId),
            userName: item.userName,
        },
        _a;
    var _a;
}
//# sourceMappingURL=project-feed.transformers.js.map

/***/ })

},[1]);


// WEBPACK FOOTER //
// main.eea0078a5e14bb42b138.bundle.js